import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { Dialog as Dialog$2, Divider, Content, Heading, ButtonGroup, Button, Header, View as View$1, Flex, ActionButton, Text, TooltipTrigger, Tooltip, Picker, Item, IllustratedMessage, DialogContainer, useDialogContainer, Grid, SearchField, useAsyncList, CheckboxGroup, Checkbox, ActionGroup, Icon, MenuTrigger, Menu, ListBox, ProgressCircle, DialogTrigger, Link, Image, TableView as TableView$2, TableHeader, Column, TableBody } from '@adobe/react-spectrum';
export { Cell, Item, Row } from '@adobe/react-spectrum';
import { defineMessages, useIntl } from 'react-intl';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useContext, createContext, useState, useEffect, useCallback, Children, useRef, useMemo } from 'react';
import { Divider as Divider$1, Header as Header$1, Breadcrumbs as Breadcrumbs$1 } from '@quarry/header';
export { ActionButton, ActionButtonGroup, Actions, CTAButton, Divider, SecondaryButton, Title } from '@quarry/header';
import { IntlProvider } from '@quarry/intl';
import Filter from '@spectrum-icons/workflow/Filter';
import _extends from '@babel/runtime/helpers/esm/extends';
import RailLeft from '@spectrum-icons/workflow/RailLeft';
import SelectBoxAll from '@spectrum-icons/workflow/SelectBoxAll';
import RSPagination from '@react/react-spectrum/Pagination';
import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import { ListView as ListView$1 } from '@react-spectrum/list';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import Provider from '@react/react-spectrum/Provider';
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger';
import { TagList, Tag } from '@react/react-spectrum/TagList';
import Tooltip$1 from '@react/react-spectrum/Tooltip';
import { ActionBarContainer, ActionBar } from '@react-spectrum/actionbar';
import { IllustratedMessage as IllustratedMessage$1, Heading as Heading$1, Content as Content$1 } from '@adobe/react-spectrum/';
import { useAdoption } from '@quarry/eim-provider';
import { useId } from '@react-aria/utils';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import ColumnSettings from '@spectrum-icons/workflow/ColumnSettings';
import SortOrderDown from '@spectrum-icons/workflow/SortOrderDown';
import SortOrderUp from '@spectrum-icons/workflow/SortOrderUp';
import GridView from '@spectrum-icons/workflow/ClassicGridView';
import ViewList from '@spectrum-icons/workflow/ViewList';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _get from '@babel/runtime/helpers/esm/get';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import Folder from '@spectrum-icons/workflow/Folder';
import FolderOpen from '@spectrum-icons/workflow/FolderOpen';
import { TreeView, TreeViewDataSource } from '@react/react-spectrum/TreeView';
import Close from '@spectrum-icons/workflow/Close';
import Star from '@spectrum-icons/workflow/Star';
import StarOutline from '@spectrum-icons/workflow/StarOutline';
import MoreSmall from '@spectrum-icons/workflow/MoreSmall';
import ChevronRight from '@spectrum-icons/workflow/ChevronRight';
import DragHandle from '@spectrum-icons/workflow/DragHandle';
import { useProvider, Provider as Provider$1 } from '@react-spectrum/provider';
import { useDrag } from '@react-aria/dnd';

var _excluded$5 = ["children"];

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$f(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ModalContext = /*#__PURE__*/createContext(null);
/** @hidden */

function DialogContextProvider(props) {
  var children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded$5);

  return /*#__PURE__*/React.createElement(ModalContext.Provider, {
    value: _objectSpread$f({}, otherProps)
  }, children);
}
function useDialogContext() {
  return useContext(ModalContext);
}

var messages$q = defineMessages({
  noneSelected: {
    id: 'headers.noneSelected',
    defaultMessage: 'None selected'
  },
  allSelected: {
    id: 'headers.allSelected',
    defaultMessage: 'All selected'
  },
  selected: {
    id: 'headers.selected',
    defaultMessage: '{selectedCount} selected'
  }
});
function getSelectionCountString() {
  var selectedItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var _ref = useDialogContext() || {},
      isSelectionRail = _ref.isSelectionRail,
      modalSelectionCount = _ref.modalSelectionCount;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var selectedString;

  if (modalSelectionCount === 'all') {
    selectedString = isSelectionRail ? formatMessage(messages$q.selected, {
      selectedCount: selectedItems.length
    }) : formatMessage(messages$q.allSelected);
  } else if (modalSelectionCount === 0) {
    selectedString = formatMessage(messages$q.noneSelected);
  } else {
    selectedString = formatMessage(messages$q.selected, {
      selectedCount: modalSelectionCount
    });
  }

  return selectedString;
}
function getSelectionString() {
  return getSelectionCountString();
}
var SelectionCount = function () {
  return /*#__PURE__*/React.createElement("span", null, getSelectionString());
};

var en_us = {
	"dialog.add": "Add",
	"dialog.addAssets": "Add Assets",
	"dialog.apply": "Apply",
	"dialog.cancel": "Cancel",
	"dialog.filters": "Filters",
	"dialog.showColumns": "Select columns to show",
	"emptyState.emptyFolder": "You have nothing in your folder",
	"emptyState.emptyFolderActions": "Return to the previous folder or create new",
	"emptyState.emptyLibrary": "You have nothing in your library",
	"emptyState.libraryFiles": "When there are files added, they will show up here",
	"emptyState.modifyCriteria": "For better results, modify your criteria",
	"emptyState.noResultsFound": "No results found",
	"folderPanel.loadingFolders": "Loading folders",
	"folderRail.collections": "Collections",
	"headers.allSelected": "All selected",
	"headers.chooseSortBy": "Choose sort by",
	"headers.clearAll": "Clear all",
	"headers.countMany": "{displayCount} of many",
	"headers.customize": "Customize",
	"headers.displayCount": "{displayCount} of {total}",
	"headers.favorite": "Favorite",
	"headers.filterCount": "{quantity, plural, one {filter} other {filters}}",
	"headers.filteringBy": "FILTERING BY",
	"headers.noneSelected": "None selected",
	"headers.openFilters": "Open filters",
	"headers.others": "{quantity, plural, one {other} other {others}}",
	"headers.search": "Search",
	"headers.sectionPicker": "Section picker",
	"headers.selected": "{selectedCount} selected",
	"headers.showFilters": "Show filters",
	"headers.showFolders": "Show folders",
	"headers.showSelections": "Show selections",
	"headers.sortBy": "Sort by",
	"headers.sortDirection": "Sort direction",
	"headers.toggleColumns": "Toggle columns",
	"list.dragHandle": "Drag handle",
	"pagination.itemsPerPage": "Items per page",
	"rails.hideFilters": "Hide filters",
	"rails.hideFolders": "Hide folders",
	"selectedItem.remove": "Remove",
	"selectionRail.selectItems": "Select items",
	"selectionRail.selectedList": "Selected items",
	"toggleableRail.clear": "Clear all",
	"views.grid": "grid",
	"views.gridView": "Grid view",
	"views.list": "list",
	"views.listView": "List view",
	"views.moreActions": "More actions",
	"views.table": "table",
	"views.tableView": "Table view",
	"views.view": "view"
};

var ko_kr = {
	"dialog.add": "추가",
	"dialog.addAssets": "에셋 추가",
	"dialog.apply": "적용",
	"dialog.cancel": "취소",
	"dialog.filters": "필터",
	"dialog.showColumns": "표시할 열 선택",
	"emptyState.emptyFolder": "폴더가 비어 있음",
	"emptyState.emptyFolderActions": "이전 폴더로 돌아가거나 새 폴더 만들기",
	"emptyState.emptyLibrary": "라이브러리가 비어 있음",
	"emptyState.libraryFiles": "파일이 추가되면 여기에 표시됨",
	"emptyState.modifyCriteria": "더 나은 결과를 위해 조건 수정",
	"emptyState.noResultsFound": "검색 결과 없음",
	"folderPanel.loadingFolders": "폴더 로드 중",
	"folderRail.collections": "컬렉션",
	"headers.allSelected": "모두 선택됨",
	"headers.chooseSortBy": "정렬 기준 선택",
	"headers.clearAll": "모두 지우기",
	"headers.countMany": "다수 중 {displayCount}",
	"headers.customize": "맞춤화",
	"headers.displayCount": "{displayCount} / {total}",
	"headers.favorite": "즐겨찾기",
	"headers.filterCount": "{quantity, plural, one {필터} other {필터}}",
	"headers.filteringBy": "필터링 기준",
	"headers.noneSelected": "선택 항목 없음",
	"headers.openFilters": "필터 열기",
	"headers.others": "{quantity, plural, one {기타} other {기타}}",
	"headers.search": "검색",
	"headers.sectionPicker": "구역 선택기",
	"headers.selected": "{selectedCount} selected",
	"headers.showFilters": "필터 표시",
	"headers.showFolders": "폴더 표시",
	"headers.showSelections": "선택 사항 표시",
	"headers.sortBy": "정렬 기준",
	"headers.sortDirection": "정렬 방향",
	"headers.toggleColumns": "열 토글",
	"list.dragHandle": "드래그 핸들",
	"pagination.itemsPerPage": "페이지당 항목",
	"rails.hideFilters": "필터 숨기기",
	"rails.hideFolders": "폴더 숨기기",
	"selectedItem.remove": "제거",
	"selectionRail.selectItems": "항목 선택",
	"selectionRail.selectedList": "선택한 항목",
	"toggleableRail.clear": "모두 지우기",
	"views.grid": "격자",
	"views.gridView": "격자 보기",
	"views.list": "목록",
	"views.listView": "목록 보기",
	"views.moreActions": "추가 작업",
	"views.table": "표",
	"views.tableView": "표 보기",
	"views.view": "보기"
};

var zh_tw = {
	"dialog.add": "新增",
	"dialog.addAssets": "新增資產",
	"dialog.apply": "套用",
	"dialog.cancel": "取消",
	"dialog.filters": "篩選器",
	"dialog.showColumns": "選取要顯示的欄",
	"emptyState.emptyFolder": "您的檔案夾中沒有任何內容",
	"emptyState.emptyFolderActions": "返回上一個檔案夾或建立新檔案夾",
	"emptyState.emptyLibrary": "您的資料庫中沒有任何內容",
	"emptyState.libraryFiles": "當新增檔案時，檔案將顯示在這裡",
	"emptyState.modifyCriteria": "為獲得最佳結果，請修改您的條件",
	"emptyState.noResultsFound": "找不到任何結果",
	"folderPanel.loadingFolders": "正在載入檔案夾",
	"folderRail.collections": "集合",
	"headers.allSelected": "全部選取",
	"headers.chooseSortBy": "選擇排序依據",
	"headers.clearAll": "全部清除",
	"headers.countMany": "多個中的 {displayCount} 個",
	"headers.customize": "自訂",
	"headers.displayCount": "{displayCount}/{total}",
	"headers.favorite": "加入我的最愛",
	"headers.filterCount": "{quantity, plural, one {篩選器} other {篩選器}}",
	"headers.filteringBy": "篩選依據",
	"headers.noneSelected": "未選取",
	"headers.openFilters": "開啟篩選器",
	"headers.others": "{quantity, plural, one {個其他項目} other {個其他項目}}",
	"headers.search": "搜尋",
	"headers.sectionPicker": "區段揀選器",
	"headers.selected": "{selectedCount} selected",
	"headers.showFilters": "顯示篩選器",
	"headers.showFolders": "顯示檔案夾",
	"headers.showSelections": "顯示選取範圍",
	"headers.sortBy": "排序依據",
	"headers.sortDirection": "排序方向",
	"headers.toggleColumns": "切換欄",
	"list.dragHandle": "拖曳控點",
	"pagination.itemsPerPage": "每頁項目數",
	"rails.hideFilters": "隱藏篩選器",
	"rails.hideFolders": "隱藏檔案夾",
	"selectedItem.remove": "移除",
	"selectionRail.selectItems": "選取項目",
	"selectionRail.selectedList": "選取的項目",
	"toggleableRail.clear": "全部清除",
	"views.grid": "網格",
	"views.gridView": "縮圖檢視",
	"views.list": "清單",
	"views.listView": "清單檢視",
	"views.moreActions": "更多動作",
	"views.table": "表格",
	"views.tableView": "表格檢視",
	"views.view": "檢視"
};

var zh_cn = {
	"dialog.add": "添加",
	"dialog.addAssets": "添加资源",
	"dialog.apply": "应用",
	"dialog.cancel": "取消",
	"dialog.filters": "过滤器",
	"dialog.showColumns": "选择要显示的列",
	"emptyState.emptyFolder": "您的文件夹中没有任何内容",
	"emptyState.emptyFolderActions": "返回上一个文件夹或创建新文件夹",
	"emptyState.emptyLibrary": "您的库中没有任何内容",
	"emptyState.libraryFiles": "添加文件后，它们将显示在此处",
	"emptyState.modifyCriteria": "为了获得更好的结果，请修改您的条件",
	"emptyState.noResultsFound": "未找到结果",
	"folderPanel.loadingFolders": "正在加载文件夹",
	"folderRail.collections": "收藏集",
	"headers.allSelected": "全部选定",
	"headers.chooseSortBy": "选择排序依据",
	"headers.clearAll": "全部清除",
	"headers.countMany": "第 {displayCount} 个，共有多个",
	"headers.customize": "自定义",
	"headers.displayCount": "第 {displayCount} 个，共 {total} 个",
	"headers.favorite": "收藏",
	"headers.filterCount": "{quantity, plural, one {个过滤器} other {个过滤器}}",
	"headers.filteringBy": "筛选条件",
	"headers.noneSelected": "未选择",
	"headers.openFilters": "打开过滤器",
	"headers.others": "{quantity, plural, one {个其他项} other {个其他项}}",
	"headers.search": "搜索",
	"headers.sectionPicker": "章节选取器",
	"headers.selected": "{selectedCount} selected",
	"headers.showFilters": "显示过滤器",
	"headers.showFolders": "显示文件夹",
	"headers.showSelections": "显示选择",
	"headers.sortBy": "排序依据",
	"headers.sortDirection": "排序方向",
	"headers.toggleColumns": "切换列",
	"list.dragHandle": "拖动手柄",
	"pagination.itemsPerPage": "每页项数",
	"rails.hideFilters": "隐藏过滤器",
	"rails.hideFolders": "隐藏文件夹",
	"selectedItem.remove": "删除",
	"selectionRail.selectItems": "选择项目",
	"selectionRail.selectedList": "选定项目",
	"toggleableRail.clear": "全部清除",
	"views.grid": "网格",
	"views.gridView": "网格视图",
	"views.list": "列表",
	"views.listView": "列表视图",
	"views.moreActions": "更多操作",
	"views.table": "表",
	"views.tableView": "表格视图",
	"views.view": "视图"
};

var pt_br = {
	"dialog.add": "Adicionar",
	"dialog.addAssets": "Adicionar ativos",
	"dialog.apply": "Aplicar",
	"dialog.cancel": "Cancelar",
	"dialog.filters": "Filtros",
	"dialog.showColumns": "Selecionar colunas a serem mostradas",
	"emptyState.emptyFolder": "Sua pasta está vazia",
	"emptyState.emptyFolderActions": "Retornar à pasta anterior ou criar uma nova",
	"emptyState.emptyLibrary": "Sua biblioteca está vazia",
	"emptyState.libraryFiles": "Os arquivos adicionados aparecerão aqui",
	"emptyState.modifyCriteria": "Para obter melhores resultados, modifique os critérios",
	"emptyState.noResultsFound": "Nenhum resultado encontrado",
	"folderPanel.loadingFolders": "Carregando pastas",
	"folderRail.collections": "Coleções",
	"headers.allSelected": "Todos selecionados",
	"headers.chooseSortBy": "Classificar por",
	"headers.clearAll": "Limpar tudo",
	"headers.countMany": "{displayCount} de muitos",
	"headers.customize": "Personalizar",
	"headers.displayCount": "{displayCount} de {total}",
	"headers.favorite": "Favorito",
	"headers.filterCount": "{quantity, plural, one {filtro} other {filtros}}",
	"headers.filteringBy": "FILTRAR POR",
	"headers.noneSelected": "Nenhum selecionado",
	"headers.openFilters": "Abrir filtros",
	"headers.others": "{quantity, plural, one {outro} other {outros}}",
	"headers.search": "Pesquisa",
	"headers.sectionPicker": "Seletor de seção",
	"headers.selected": "{selectedCount} selected",
	"headers.showFilters": "Exibir filtros",
	"headers.showFolders": "Mostrar pastas",
	"headers.showSelections": "Mostrar seleções",
	"headers.sortBy": "Classificar por",
	"headers.sortDirection": "Classificar direção",
	"headers.toggleColumns": "Alternar colunas",
	"list.dragHandle": "Arrastar alça",
	"pagination.itemsPerPage": "Itens por página",
	"rails.hideFilters": "Ocultar filtros",
	"rails.hideFolders": "Ocultar pastas",
	"selectedItem.remove": "Remover",
	"selectionRail.selectItems": "Selecionar itens",
	"selectionRail.selectedList": "Itens selecionados",
	"toggleableRail.clear": "Limpar tudo",
	"views.grid": "grade",
	"views.gridView": "Visualização em grade",
	"views.list": "lista",
	"views.listView": "Visualização em lista",
	"views.moreActions": "Mais ações",
	"views.table": "tabela",
	"views.tableView": "Visualização em tabela",
	"views.view": "visualização"
};

var it_it = {
	"dialog.add": "Aggiungi",
	"dialog.addAssets": "Aggiungi risorse",
	"dialog.apply": "Applica",
	"dialog.cancel": "Annulla",
	"dialog.filters": "Filtri",
	"dialog.showColumns": "Seleziona le colonne da mostrare",
	"emptyState.emptyFolder": "Nessun elemento nella cartella",
	"emptyState.emptyFolderActions": "Torna alla cartella precedente o creane una nuova",
	"emptyState.emptyLibrary": "La libreria è vuota",
	"emptyState.libraryFiles": "I file aggiunti verranno visualizzati qui",
	"emptyState.modifyCriteria": "Per ottenere risultati migliori, modifica i criteri",
	"emptyState.noResultsFound": "Nessun risultato",
	"folderPanel.loadingFolders": "Caricamento cartelle",
	"folderRail.collections": "Raccolte",
	"headers.allSelected": "Tutti selezionati",
	"headers.chooseSortBy": "Scegli Ordina per",
	"headers.clearAll": "Cancella tutto",
	"headers.countMany": "{displayCount} di molti",
	"headers.customize": "Personalizza",
	"headers.displayCount": "{displayCount} di {total}",
	"headers.favorite": "Preferito",
	"headers.filterCount": "{quantity, plural, one {filtro} other {filtri}}",
	"headers.filteringBy": "FILTRA PER",
	"headers.noneSelected": "Nessuna selezione",
	"headers.openFilters": "Apri filtri",
	"headers.others": "{quantity, plural, one {altro} other {altri}}",
	"headers.search": "Ricerca",
	"headers.sectionPicker": "Selettore sezione",
	"headers.selected": "{selectedCount} selected",
	"headers.showFilters": "Mostra filtri",
	"headers.showFolders": "Mostra cartelle",
	"headers.showSelections": "Mostra selezioni",
	"headers.sortBy": "Ordina per",
	"headers.sortDirection": "Direzione di ordinamento",
	"headers.toggleColumns": "Attiva/Disattiva colonne",
	"list.dragHandle": "Trascina la maniglia",
	"pagination.itemsPerPage": "Elementi per pagina",
	"rails.hideFilters": "Nascondi filtri",
	"rails.hideFolders": "Nascondi cartelle",
	"selectedItem.remove": "Rimuovi",
	"selectionRail.selectItems": "Seleziona elementi",
	"selectionRail.selectedList": "Elementi selezionati",
	"toggleableRail.clear": "Cancella tutto",
	"views.grid": "griglia",
	"views.gridView": "Vista a griglia",
	"views.list": "elenco",
	"views.listView": "Vista a elenco",
	"views.moreActions": "Altre azioni",
	"views.table": "tabella",
	"views.tableView": "Vista tabella",
	"views.view": "visualizzazione"
};

var es_es = {
	"dialog.add": "Añadir",
	"dialog.addAssets": "Añadir assets",
	"dialog.apply": "Aplicar",
	"dialog.cancel": "Cancelar",
	"dialog.filters": "Filtros",
	"dialog.showColumns": "Seleccionar columnas para mostrar",
	"emptyState.emptyFolder": "No tiene nada en la carpeta",
	"emptyState.emptyFolderActions": "Volver a la carpeta anterior o crear una nueva",
	"emptyState.emptyLibrary": "No tiene nada en la biblioteca",
	"emptyState.libraryFiles": "Cuando se añadan archivos, aparecerán aquí",
	"emptyState.modifyCriteria": "Para obtener mejores resultados, modifique sus criterios",
	"emptyState.noResultsFound": "No se han encontrado resultados",
	"folderPanel.loadingFolders": "Cargando carpetas",
	"folderRail.collections": "Colecciones",
	"headers.allSelected": "Todo seleccionado",
	"headers.chooseSortBy": "Ordenar por",
	"headers.clearAll": "Borrar todo",
	"headers.countMany": "{displayCount} de varios",
	"headers.customize": "Personalizar",
	"headers.displayCount": "{displayCount} de {total}",
	"headers.favorite": "Favorito",
	"headers.filterCount": "{quantity, plural, one {filtro} other {filtros}}",
	"headers.filteringBy": "FILTRAR POR",
	"headers.noneSelected": "Ninguno seleccionado",
	"headers.openFilters": "Abrir filtros",
	"headers.others": "{quantity, plural, one {más} other {más}}",
	"headers.search": "Buscar",
	"headers.sectionPicker": "Selector de sección",
	"headers.selected": "{selectedCount} selected",
	"headers.showFilters": "Mostrar filtros",
	"headers.showFolders": "Mostrar carpetas",
	"headers.showSelections": "Mostrar selecciones",
	"headers.sortBy": "Ordenar por",
	"headers.sortDirection": "Ordenar dirección",
	"headers.toggleColumns": "Alternar columnas",
	"list.dragHandle": "Control para arrastar",
	"pagination.itemsPerPage": "Elementos por página",
	"rails.hideFilters": "Ocultar filtros",
	"rails.hideFolders": "Ocultar carpetas",
	"selectedItem.remove": "Eliminar",
	"selectionRail.selectItems": "Seleccionar elementos",
	"selectionRail.selectedList": "Elementos seleccionados",
	"toggleableRail.clear": "Borrar todo",
	"views.grid": "cuadrícula",
	"views.gridView": "Vista de cuadrícula",
	"views.list": "lista",
	"views.listView": "Vista de lista",
	"views.moreActions": "Más acciones",
	"views.table": "tabla",
	"views.tableView": "Vista de tabla",
	"views.view": "vista"
};

var ja_jp = {
	"dialog.add": "追加",
	"dialog.addAssets": "アセットを追加",
	"dialog.apply": "適用",
	"dialog.cancel": "キャンセル",
	"dialog.filters": "フィルター",
	"dialog.showColumns": "表示する列を選択",
	"emptyState.emptyFolder": "フォルダーに何もありません",
	"emptyState.emptyFolderActions": "前のフォルダーに戻るか新規作成",
	"emptyState.emptyLibrary": "ライブラリに何もありません",
	"emptyState.libraryFiles": "追加されたファイルがある場合、ここに表示されます",
	"emptyState.modifyCriteria": "より良い結果を得るには、条件を変更してください",
	"emptyState.noResultsFound": "結果が見つかりません",
	"folderPanel.loadingFolders": "フォルダーを読み込み中",
	"folderRail.collections": "コレクション",
	"headers.allSelected": "すべて選択済み",
	"headers.chooseSortBy": "並べ替え基準を選択",
	"headers.clearAll": "すべてクリア",
	"headers.countMany": "多数のうちの {displayCount} 件",
	"headers.customize": "カスタマイズ",
	"headers.displayCount": "{displayCount} / {total}",
	"headers.favorite": "お気に入り",
	"headers.filterCount": "{quantity, plural, one {フィルター} other {フィルター}}",
	"headers.filteringBy": "フィルタリング基準",
	"headers.noneSelected": "未選択",
	"headers.openFilters": "フィルターを開く",
	"headers.others": "{quantity, plural, one {その他} other {その他}}",
	"headers.search": "検索",
	"headers.sectionPicker": "セクションピッカー",
	"headers.selected": "{selectedCount} selected",
	"headers.showFilters": "フィルターを表示",
	"headers.showFolders": "フォルダーを表示",
	"headers.showSelections": "選択項目を表示",
	"headers.sortBy": "並べ替え基準",
	"headers.sortDirection": "並べ替え方向",
	"headers.toggleColumns": "列を切り替え",
	"list.dragHandle": "ドラッグハンドル",
	"pagination.itemsPerPage": "1 ページあたりの項目数",
	"rails.hideFilters": "フィルターを非表示",
	"rails.hideFolders": "フォルダーを非表示",
	"selectedItem.remove": "削除",
	"selectionRail.selectItems": "項目を選択",
	"selectionRail.selectedList": "選択された項目",
	"toggleableRail.clear": "すべてクリア",
	"views.grid": "格子",
	"views.gridView": "グリッド表示",
	"views.list": "リスト",
	"views.listView": "リスト表示",
	"views.moreActions": "その他のアクション",
	"views.table": "テーブル",
	"views.tableView": "テーブル表示",
	"views.view": "表示"
};

var de_de = {
	"dialog.add": "Hinzufügen",
	"dialog.addAssets": "Assets Hinzufügen",
	"dialog.apply": "Anwenden",
	"dialog.cancel": "Abbrechen",
	"dialog.filters": "Filter",
	"dialog.showColumns": "Anzuzeigende Spalten auswählen",
	"emptyState.emptyFolder": "Der Ordner ist leer.",
	"emptyState.emptyFolderActions": "Kehren Sie zum vorherigen Ordner zurück oder erstellen Sie einen neuen.",
	"emptyState.emptyLibrary": "Die Bibliothek ist leer.",
	"emptyState.libraryFiles": "Hier werden hinzugefügte Dateien angezeigt.",
	"emptyState.modifyCriteria": "Kriterien ändern, um bessere Ergebnisse zu erhalten",
	"emptyState.noResultsFound": "Keine Ergebnisse gefunden",
	"folderPanel.loadingFolders": "Ordner werden geladen",
	"folderRail.collections": "Sammlungen",
	"headers.allSelected": "Alle ausgewählten",
	"headers.chooseSortBy": "„Sortieren nach“ auswählen",
	"headers.clearAll": "Alles löschen",
	"headers.countMany": "{displayCount} von vielen",
	"headers.customize": "Anpassen",
	"headers.displayCount": "{displayCount} von {total}",
	"headers.favorite": "Favorit",
	"headers.filterCount": "{quantity, plural, one {Filter} other {Filter}}",
	"headers.filteringBy": "FILTERN NACH",
	"headers.noneSelected": "Keine Auswahl getroffen",
	"headers.openFilters": "Filter öffnen",
	"headers.others": "{quantity, plural, one {anderer} other {andere}}",
	"headers.search": "Suchen",
	"headers.sectionPicker": "Abschnittsauswahl",
	"headers.selected": "{selectedCount} selected",
	"headers.showFilters": "Filter zeigen",
	"headers.showFolders": "Ordner anzeigen",
	"headers.showSelections": "Auswahl anzeigen",
	"headers.sortBy": "Sortieren nach",
	"headers.sortDirection": "Sortierrichtung",
	"headers.toggleColumns": "Spalten ein/aus",
	"list.dragHandle": "Griff ziehen",
	"pagination.itemsPerPage": "Elemente pro Seite",
	"rails.hideFilters": "Filter ausblenden",
	"rails.hideFolders": "Ordner ausblenden",
	"selectedItem.remove": "Entfernen",
	"selectionRail.selectItems": "Elemente auswählen",
	"selectionRail.selectedList": "Ausgewählte Elemente",
	"toggleableRail.clear": "Alles löschen",
	"views.grid": "Gitter",
	"views.gridView": "Rasteransicht",
	"views.list": "Liste",
	"views.listView": "Listenansicht",
	"views.moreActions": "Mehr Aktionen",
	"views.table": "Tabelle",
	"views.tableView": "Tabellenansicht",
	"views.view": "Ansicht"
};

var fr_fr = {
	"dialog.add": "Ajouter",
	"dialog.addAssets": "Ajouter les ressources",
	"dialog.apply": "Appliquer",
	"dialog.cancel": "Annuler",
	"dialog.filters": "Filtres",
	"dialog.showColumns": "Sélectionner les colonnes à afficher",
	"emptyState.emptyFolder": "Votre dossier est vide",
	"emptyState.emptyFolderActions": "Revenir au dossier précédent ou en créer un nouveau",
	"emptyState.emptyLibrary": "Votre bibliothèque est vide",
	"emptyState.libraryFiles": "Si des fichiers sont ajoutés, ils apparaîtront ici",
	"emptyState.modifyCriteria": "Pour des résultats plus précis, modifiez vos critères.",
	"emptyState.noResultsFound": "Aucun résultat trouvé",
	"folderPanel.loadingFolders": "Chargement des dossiers",
	"folderRail.collections": "Collections",
	"headers.allSelected": "Tous sélectionnés",
	"headers.chooseSortBy": "Choisir le tri par",
	"headers.clearAll": "Tout effacer",
	"headers.countMany": "{displayCount} sur plusieurs",
	"headers.customize": "Personnaliser",
	"headers.displayCount": "{displayCount} sur {total}",
	"headers.favorite": "Favori",
	"headers.filterCount": "{quantity, plural, one {filtre} other {filtres}}",
	"headers.filteringBy": "FILTRER PAR",
	"headers.noneSelected": "Aucun élément sélectionné",
	"headers.openFilters": "Ouvrir les filtres",
	"headers.others": "{quantity, plural, one {autre} other {autres}}",
	"headers.search": "Rechercher",
	"headers.sectionPicker": "Sélectionneur de section",
	"headers.selected": "{selectedCount} selected",
	"headers.showFilters": "Afficher les filtres",
	"headers.showFolders": "Afficher les dossiers",
	"headers.showSelections": "Afficher les sélections",
	"headers.sortBy": "Trier par",
	"headers.sortDirection": "Direction du tri",
	"headers.toggleColumns": "Activer/désactiver les colonnes",
	"list.dragHandle": "Faire glisser la poignée",
	"pagination.itemsPerPage": "Éléments par page",
	"rails.hideFilters": "Masquer les filtres",
	"rails.hideFolders": "Masquer les dossiers",
	"selectedItem.remove": "Supprimer",
	"selectionRail.selectItems": "Sélectionner des éléments",
	"selectionRail.selectedList": "Eléments sélectionnés",
	"toggleableRail.clear": "Tout effacer",
	"views.grid": "grille",
	"views.gridView": "Vue Grille",
	"views.list": "liste",
	"views.listView": "Vue Liste",
	"views.moreActions": "Plus d’action",
	"views.table": "tableau",
	"views.tableView": "Vue Tableau",
	"views.view": "vue"
};

/* istanbul ignore file */

var localizationMessages = /*#__PURE__*/Object.freeze({
  __proto__: null,
  en_US: en_us,
  ko_KR: ko_kr,
  zh_TW: zh_tw,
  zh_CN: zh_cn,
  pt_BR: pt_br,
  it_IT: it_it,
  es_ES: es_es,
  ja_JP: ja_jp,
  de_DE: de_de,
  fr_FR: fr_fr
});

var messages$p = defineMessages({
  addAssets: {
    id: 'dialog.addAssets',
    defaultMessage: 'Add Assets'
  },
  add: {
    id: 'dialog.add',
    defaultMessage: 'Add'
  },
  cancel: {
    id: 'dialog.cancel',
    defaultMessage: 'Cancel'
  }
});
function Dialog$1(props) {
  var title = props.title,
      confirmLabel = props.confirmLabel,
      cancelLabel = props.cancelLabel,
      locale = props.locale,
      _props$onClose = props.onClose,
      onClose = _props$onClose === void 0 ? function () {} : _props$onClose,
      _props$onConfirm = props.onConfirm,
      onConfirm = _props$onConfirm === void 0 ? function () {} : _props$onConfirm,
      children = props.children; // state

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      modalSelectionCount = _useState2[0],
      setModalSelectionCount = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isSelectionRail = _useState4[0],
      setIsSelectionRail = _useState4[1]; // Hide header if selection rail is being used


  var header = isSelectionRail ? null : /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(SelectionCount, null), /*#__PURE__*/React.createElement(Divider$1, null));
  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale,
    messages: localizationMessages
  }, /*#__PURE__*/React.createElement(DialogContextProvider, {
    modalSelectionCount: modalSelectionCount,
    setModalSelectionCount: setModalSelectionCount,
    isSelectionRail: isSelectionRail,
    setIsSelectionRail: setIsSelectionRail
  }, /*#__PURE__*/React.createElement(Dialog$2, null, /*#__PURE__*/React.createElement(DialogTitle, {
    title: title
  }), header, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Content, null, children), /*#__PURE__*/React.createElement(DialogButtons, {
    cancelLabel: cancelLabel,
    confirmLabel: confirmLabel,
    onConfirm: onConfirm,
    onClose: onClose,
    selectionCount: modalSelectionCount
  }))));
} // the following components were created to support the intl hooks (can't do in the Dialog component)

/** @hidden */

function DialogTitle(props) {
  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var _props$title = props.title,
      title = _props$title === void 0 ? formatMessage(messages$p.addAssets) : _props$title;
  return /*#__PURE__*/React.createElement(Heading, null, title);
}
/** @hidden */


function DialogButtons(props) {
  var _useIntl2 = useIntl(),
      formatMessage = _useIntl2.formatMessage;

  var _props$cancelLabel = props.cancelLabel,
      cancelLabel = _props$cancelLabel === void 0 ? formatMessage(messages$p.cancel) : _props$cancelLabel,
      _props$confirmLabel = props.confirmLabel,
      confirmLabel = _props$confirmLabel === void 0 ? formatMessage(messages$p.add) : _props$confirmLabel,
      selectionCount = props.selectionCount,
      onConfirm = props.onConfirm,
      onClose = props.onClose;
  return /*#__PURE__*/React.createElement(ButtonGroup, {
    alignSelf: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    isQuiet: true,
    variant: "secondary",
    onPress: onClose
  }, cancelLabel), /*#__PURE__*/React.createElement(Button, {
    variant: "cta",
    isDisabled: !selectionCount,
    onPress: onConfirm
  }, confirmLabel));
}

var AuxViewType; // maps to same enum value in AuxViewType
// used for view setting rail reporting/setting

(function (AuxViewType) {
  AuxViewType[AuxViewType["FOLDER_RAIL"] = 0] = "FOLDER_RAIL";
  AuxViewType[AuxViewType["FILTER_RAIL"] = 1] = "FILTER_RAIL";
  AuxViewType[AuxViewType["FILTER_DIALOG"] = 2] = "FILTER_DIALOG";
  AuxViewType[AuxViewType["SELECTION_RAIL"] = 3] = "SELECTION_RAIL";
})(AuxViewType || (AuxViewType = {}));

var AuxViewRail;

(function (AuxViewRail) {
  AuxViewRail[AuxViewRail["folder"] = 0] = "folder";
  AuxViewRail[AuxViewRail["filter"] = 1] = "filter";
})(AuxViewRail || (AuxViewRail = {}));

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$e(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ComponentContext = /*#__PURE__*/createContext(null);
var ComponentType;

(function (ComponentType) {
  ComponentType[ComponentType["BULK_ACTION_BAR"] = 0] = "BULK_ACTION_BAR";
})(ComponentType || (ComponentType = {}));

/**
 * The ComponentProvider provides specific components via the context so that the components can be placed in the
 * positions required by Inventory.
 *
 * FUTURE: move most Inventory children into this context so that filtering through inventory children (as done in
 *         DefaultLayout will not be needed (and also won't work if there are intermediary components).
 *
 * @hidden
 * */
function ComponentProvider(props) {
  var children = props.children;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      components = _useState2[0],
      setComps = _useState2[1];

  return /*#__PURE__*/React.createElement(ComponentContext.Provider, {
    value: {
      components: components,
      setComponent: function setComponent(type, component) {
        setComps(_objectSpread$e(_objectSpread$e({}, components), {}, _defineProperty({}, type, component)));
      }
    }
  }, children);
}
function useComponentContext() {
  return useContext(ComponentContext);
}

/** hidden */

function RailDivider() {
  return /*#__PURE__*/React.createElement(Divider, {
    flexShrink: 0,
    size: "M",
    marginY: "size-100",
    width: "95%",
    marginX: "auto"
  });
}

var _excluded$4 = ["children"];

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$d(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var InventoryContext = /*#__PURE__*/createContext(null);
/** @hidden */

function InventoryContextProvider(props) {
  var children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded$4);

  return /*#__PURE__*/React.createElement(InventoryContext.Provider, {
    value: _objectSpread$d({}, otherProps)
  }, children);
}
function useInventoryContext() {
  return useContext(InventoryContext);
}

var messages$o = defineMessages({
  clear: {
    id: 'toggleableRail.clear',
    defaultMessage: 'Clear all'
  }
});

/** @hidden */
function ToggleableRail(props) {
  var auxViewType = props.auxViewType,
      children = props.children,
      defaultOpen = props.defaultOpen,
      borderPosition = props.borderPosition,
      rightHeaderAction = props.rightHeaderAction,
      _props$showDivider = props.showDivider,
      showDivider = _props$showDivider === void 0 ? true : _props$showDivider,
      _props$showMargins = props.showMargins,
      showMargins = _props$showMargins === void 0 ? true : _props$showMargins,
      toggleIcon = props.toggleIcon,
      toggleValue = props.toggleValue,
      _props$width = props.width,
      width = _props$width === void 0 ? 'size-7000' : _props$width;

  var _useInventoryContext = useInventoryContext(),
      getAuxViewToggleCount = _useInventoryContext.getAuxViewToggleCount,
      isAuxViewShown = _useInventoryContext.isAuxViewShown,
      toggleAuxView = _useInventoryContext.toggleAuxView,
      useAuxView = _useInventoryContext.useAuxView;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  useEffect(function () {
    useAuxView(auxViewType, defaultOpen);
  }, []); // NOTE: this is needed for the FolderTree component. hiding/showing the rail does not trigger TreeView to reappear
  // without the resize event.
  // TODO: remove once rsp treeview is integrated into FolderTree

  useEffect(function () {
    window.dispatchEvent(new Event('resize'));
  }, [isAuxViewShown(auxViewType)]);
  var isHidden = !isAuxViewShown(auxViewType);
  // put divider based on if left/right rail
  var dividerProps = {};

  if (showDivider) {
    var _dividerProps;

    var position = borderPosition === 'left' ? 'Start' : 'End';
    dividerProps = (_dividerProps = {}, _defineProperty(_dividerProps, "border".concat(position, "Width"), 'thick'), _defineProperty(_dividerProps, "border".concat(position, "Color"), 'gray-300'), _dividerProps);
  } // TODO: figure out a better way to do height calc (replace with flexGrow={1} once list view supports it)
  // NOTE: the conditional in front of the action button is to unmount and mount an new instance when the rail is
  // hidden/opened again so that autoFocus will bring back focus to the button (since we're hiding the rail oh hide,
  // keeping the button as part of the DOM will not have it refocus once the rail is reopened)


  return /*#__PURE__*/React.createElement(View$1, _extends({
    isHidden: isHidden
  }, dividerProps, {
    paddingX: "size-100",
    height: "100%"
  }), /*#__PURE__*/React.createElement(Flex, {
    flex: "auto",
    direction: "column",
    height: "100%",
    marginTop: showMargins ? "size-150" : null,
    UNSAFE_style: {
      overflowY: "auto"
    }
  }, !isHidden && /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(ActionButton, {
    isQuiet: auxViewType !== AuxViewType.SELECTION_RAIL,
    flexShrink: 0,
    autoFocus: getAuxViewToggleCount(auxViewType) > 0,
    onPress: function onToggle() {
      return toggleAuxView(auxViewType);
    }
  }, toggleIcon, /*#__PURE__*/React.createElement(Text, null, toggleValue)), auxViewType === AuxViewType.SELECTION_RAIL ? /*#__PURE__*/React.createElement(ActionButton, {
    isQuiet: true,
    onPress: rightHeaderAction
  }, formatMessage(messages$o.clear)) : null), /*#__PURE__*/React.createElement(Flex, {
    flexGrow: 1,
    isHidden: isHidden,
    direction: "column",
    alignItems: "start",
    width: width,
    marginTop: showDivider ? null : "size-300",
    marginX: showMargins ? "size-200" : null
  }, showDivider ? /*#__PURE__*/React.createElement(RailDivider, null) : null, /*#__PURE__*/React.createElement(View$1, {
    overflow: "inherit auto",
    width: "100%",
    flexGrow: 1
  }, children))));
}

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$c(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var messages$n = defineMessages({
  hideFilters: {
    id: 'rails.hideFilters',
    defaultMessage: 'Hide filters'
  }
});
function FilterRail(props) {
  var children = props.children,
      defaultOpen = props.defaultOpen,
      _props$width = props.width,
      width = _props$width === void 0 ? '256px' : _props$width;

  var _useInventoryContext = useInventoryContext(),
      filterState = _useInventoryContext.filterState,
      onFilterChange = _useInventoryContext.onFilterChange;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/React.createElement(ToggleableRail, {
    auxViewType: AuxViewType.FILTER_RAIL,
    toggleIcon: /*#__PURE__*/React.createElement(Filter, null),
    toggleValue: formatMessage(messages$n.hideFilters),
    defaultOpen: defaultOpen,
    width: width
  }, typeof children === 'function' ? children({
    filterState: filterState.filters || {},
    onFilterChange: function onCustomFilterChange(key, value) {
      var newFilterState = _objectSpread$c(_objectSpread$c({}, filterState.filters || {}), {}, _defineProperty({}, key, value));

      onFilterChange('filters', newFilterState);
    },
    onSubmit: function onSubmit(state) {
      return onFilterChange('filters', state);
    }
  }) : children);
}

var messages$m = defineMessages({
  hideFolders: {
    id: 'rails.hideFolders',
    defaultMessage: 'Hide folders'
  }
});
function FolderRail(props) {
  var children = props.children,
      defaultOpen = props.defaultOpen,
      _props$width = props.width,
      width = _props$width === void 0 ? '256px' : _props$width;

  var _useInventoryContext = useInventoryContext(),
      filterState = _useInventoryContext.filterState,
      onFilterChange = _useInventoryContext.onFilterChange;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/React.createElement(ToggleableRail, {
    borderPosition: "right",
    auxViewType: AuxViewType.FOLDER_RAIL,
    toggleIcon: /*#__PURE__*/React.createElement(RailLeft, null),
    toggleValue: formatMessage(messages$m.hideFolders),
    defaultOpen: defaultOpen,
    width: width
  }, typeof children === 'function' ? children({
    filterState: {
      collection: filterState.collection,
      folder: filterState.folder
    },
    onFolderChange: function onFolderChange(folder) {
      return onFilterChange('folder', folder);
    },
    onCollectionChange: function onCollectionChange(collection) {
      return onFilterChange('collection', collection);
    }
  }) : children);
}

var TOOLTIP_DELAY = 500; // ms

var messages$l = defineMessages({
  showFolders: {
    id: 'headers.showFolders',
    defaultMessage: 'Show folders'
  },
  showSelections: {
    id: 'headers.showSelections',
    defaultMessage: 'Show selections'
  }
});
function PageHeader(props) {
  var children = props.children;

  var _useInventoryContext = useInventoryContext(),
      getAuxViewToggleCount = _useInventoryContext.getAuxViewToggleCount,
      isAuxViewEnabled = _useInventoryContext.isAuxViewEnabled,
      isAuxViewShown = _useInventoryContext.isAuxViewShown,
      toggleAuxView = _useInventoryContext.toggleAuxView;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/React.createElement(Header$1, {
    minHeight: "size-700"
  }, isAuxViewEnabled(AuxViewType.FOLDER_RAIL) && !isAuxViewShown(AuxViewType.FOLDER_RAIL) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TooltipTrigger, {
    delay: TOOLTIP_DELAY
  }, /*#__PURE__*/React.createElement(ActionButton, {
    "aria-label": formatMessage(messages$l.showFolders),
    isQuiet: true,
    autoFocus: getAuxViewToggleCount(AuxViewType.FOLDER_RAIL) > 0,
    onPress: function onToggle() {
      return toggleAuxView(AuxViewType.FOLDER_RAIL);
    }
  }, /*#__PURE__*/React.createElement(RailLeft, null)), /*#__PURE__*/React.createElement(Tooltip, null, formatMessage(messages$l.showFolders))), /*#__PURE__*/React.createElement(Divider, {
    size: "M",
    orientation: "vertical",
    marginX: "size-150",
    marginY: "size-150"
  })), children, isAuxViewEnabled(AuxViewType.SELECTION_RAIL) && !isAuxViewShown(AuxViewType.SELECTION_RAIL) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    size: "M",
    orientation: "vertical",
    marginX: "size-150",
    marginY: "size-150"
  }), /*#__PURE__*/React.createElement(TooltipTrigger, {
    delay: TOOLTIP_DELAY
  }, /*#__PURE__*/React.createElement(ActionButton, {
    "aria-label": formatMessage(messages$l.showSelections),
    autoFocus: getAuxViewToggleCount(AuxViewType.SELECTION_RAIL) > 0,
    onPress: function onPress() {
      return toggleAuxView(AuxViewType.SELECTION_RAIL);
    }
  }, /*#__PURE__*/React.createElement(SelectBoxAll, null), /*#__PURE__*/React.createElement(Text, null, getSelectionString())), /*#__PURE__*/React.createElement(Tooltip, null, formatMessage(messages$l.showSelections)))));
}

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$b(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$b(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var messages$k = defineMessages({
  itemsPerPage: {
    id: 'pagination.itemsPerPage',
    defaultMessage: 'Items per page'
  }
});
function Pagination(props) {
  var _props$pageLimits = props.pageLimits,
      pageLimits = _props$pageLimits === void 0 ? [] : _props$pageLimits;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var _useInventoryContext = useInventoryContext(),
      onFilterChange = _useInventoryContext.onFilterChange,
      pagination = _useInventoryContext.pagination;

  var currentPage = pagination.page,
      pageLimit = pagination.limit,
      total = pagination.total;
  var totalPages = Math.ceil(total / pageLimit);

  var onPaginationChange = function (newPageState) {
    return onFilterChange('pagination', newPageState);
  };

  var onRSPaginationChange = function (newPage) {
    var newPageState = _objectSpread$b(_objectSpread$b({}, pagination), {}, {
      page: newPage
    });

    onPaginationChange(newPageState);
  };

  var onLimitSelection = function (selected) {
    var selectedLimit = Number(selected);
    var newTotalPages = Math.ceil(total / selectedLimit);
    var newCurrentPage = newTotalPages < currentPage ? newTotalPages : currentPage;

    var newPageState = _objectSpread$b(_objectSpread$b({}, pagination), {}, {
      page: newCurrentPage,
      limit: selectedLimit
    });

    onPaginationChange(newPageState);
  };

  return /*#__PURE__*/React.createElement(Flex, {
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    margin: "size-100"
  }, /*#__PURE__*/React.createElement(RSPagination, {
    mode: "primary",
    variant: "explicit",
    defaultPage: 1,
    currentPage: currentPage,
    totalPages: totalPages,
    onChange: onRSPaginationChange,
    onPrevious: onRSPaginationChange,
    onNext: onRSPaginationChange
  }), pageLimits.length > 1 && /*#__PURE__*/React.createElement(View$1, {
    position: "absolute",
    right: "size-0"
  }, /*#__PURE__*/React.createElement(Picker, {
    isQuiet: true,
    label: formatMessage(messages$k.itemsPerPage),
    labelPosition: "side",
    items: pageLimits.map(function (limit) {
      return {
        limit: limit,
        label: limit.toString()
      };
    }),
    defaultSelectedKey: pageLimit.toString(),
    onSelectionChange: function onSelectionChange(selected) {
      return onLimitSelection(selected);
    }
  }, function (item) {
    return /*#__PURE__*/React.createElement(Item, {
      key: item.limit
    }, item.label);
  })));
}

var SelectedItemsSVG = function () {
  return /*#__PURE__*/React.createElement("svg", {
    id: "SelectedItems_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 60",
    enableBackground: "new 0 0 80 60;",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, '.st0{fill:#B3B4B4;}.st1{fill:#1373E6;}'), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "list_lg_3_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.193,54.536H7.807c-1.148,0-2.082-0.934-2.082-2.082V7.546c0-1.148,0.934-2.082,2.082-2.082h64.386 c1.148,0,2.082,0.934,2.082,2.082v44.908C74.275,53.603,73.342,54.536,72.193,54.536z M7.807,7.464 c-0.045,0-0.082,0.037-0.082,0.082v44.908c0,0.045,0.037,0.082,0.082,0.082h64.386c0.045,0,0.082-0.037,0.082-0.082V7.546 c0-0.044-0.037-0.082-0.082-0.082H7.807z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.942,14.415l-51.856-0.004c-0.414,0-0.75-0.336-0.75-0.75s0.336-0.75,0.75-0.75l51.857,0.004 c0.414,0,0.75,0.336,0.75,0.75S66.356,14.415,65.942,14.415z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.397,47.086h-2.479c-0.873,0-1.582-0.71-1.582-1.582v-2.479c0-0.872,0.709-1.582,1.582-1.582h2.479 c0.873,0,1.582,0.71,1.582,1.582v2.479C18.979,46.376,18.27,47.086,17.397,47.086z M14.918,42.942 c-0.045,0-0.082,0.037-0.082,0.082v2.479c0,0.045,0.037,0.082,0.082,0.082h2.479c0.045,0,0.082-0.037,0.082-0.082v-2.479 c0-0.045-0.037-0.082-0.082-0.082H14.918z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.397,39.139h-2.479c-0.873,0-1.582-0.71-1.582-1.582v-2.479c0-0.872,0.709-1.582,1.582-1.582h2.479 c0.873,0,1.582,0.71,1.582,1.582v2.479C18.979,38.429,18.27,39.139,17.397,39.139z M14.918,34.995 c-0.045,0-0.082,0.037-0.082,0.082v2.479c0,0.045,0.037,0.082,0.082,0.082h2.479c0.045,0,0.082-0.037,0.082-0.082v-2.479 c0-0.045-0.037-0.082-0.082-0.082H14.918z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.397,31.191h-2.479c-0.873,0-1.582-0.71-1.582-1.582V27.13c0-0.873,0.709-1.582,1.582-1.582h2.479 c0.873,0,1.582,0.709,1.582,1.582v2.479C18.979,30.481,18.27,31.191,17.397,31.191z M14.918,27.048 c-0.045,0-0.082,0.037-0.082,0.082v2.479c0,0.045,0.037,0.082,0.082,0.082h2.479c0.045,0,0.082-0.037,0.082-0.082V27.13 c0-0.045-0.037-0.082-0.082-0.082C17.397,27.048,14.918,27.048,14.918,27.048z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.808,23.277L45.808,23.277l-23.647-0.033c-0.871,0-1.581-0.709-1.581-1.582v-2.479 c0-0.873,0.709-1.582,1.582-1.582l23.647,0.033c0.871,0,1.581,0.709,1.581,1.582v2.479C47.39,22.567,46.68,23.277,45.808,23.277z M22.161,19.101c-0.044,0-0.081,0.037-0.081,0.082v2.479c0,0.045,0.037,0.082,0.082,0.082l23.646,0.033 c0.045,0,0.082-0.037,0.082-0.082v-2.479c0-0.046-0.036-0.082-0.082-0.082L22.161,19.101z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.808,31.208L45.808,31.208l-23.647-0.033c-0.871,0-1.581-0.71-1.581-1.582v-2.479 c0-0.873,0.709-1.582,1.582-1.582l23.647,0.033c0.871,0,1.581,0.709,1.581,1.582v2.479C47.39,30.498,46.68,31.208,45.808,31.208z M22.161,27.031c-0.044,0-0.081,0.037-0.081,0.082v2.479c0,0.045,0.037,0.082,0.082,0.082l23.646,0.033 c0.045,0,0.082-0.037,0.082-0.082v-2.479c0-0.045-0.037-0.082-0.082-0.082L22.161,27.031z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.808,39.139L45.808,39.139l-23.647-0.033c-0.871,0-1.581-0.71-1.581-1.582v-2.479 c0-0.872,0.709-1.582,1.582-1.582l23.647,0.033c0.871,0,1.581,0.71,1.581,1.582v2.479C47.39,38.429,46.68,39.139,45.808,39.139z M22.161,34.962c-0.044,0-0.081,0.037-0.081,0.082v2.479c0,0.045,0.037,0.082,0.082,0.082l23.646,0.033 c0.045,0,0.082-0.037,0.082-0.082v-2.479c0-0.046-0.036-0.082-0.082-0.082L22.161,34.962z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.808,47.069L45.808,47.069l-23.647-0.033c-0.871,0-1.581-0.71-1.581-1.582v-2.479 c0-0.872,0.709-1.582,1.582-1.582l23.647,0.033c0.871,0,1.581,0.71,1.581,1.582v2.479C47.39,46.359,46.68,47.069,45.808,47.069z M22.161,42.893c-0.044,0-0.081,0.037-0.081,0.082v2.479c0,0.046,0.036,0.082,0.082,0.082l23.646,0.033 c0.045,0,0.082-0.037,0.082-0.082v-2.479c0-0.045-0.037-0.082-0.082-0.082L22.161,42.893z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.397,23.244h-2.479c-0.873,0-1.582-0.709-1.582-1.582v-2.479c0-0.873,0.709-1.582,1.582-1.582h2.479 c0.873,0,1.582,0.709,1.582,1.582v2.479C18.979,22.534,18.27,23.244,17.397,23.244z M14.918,19.101 c-0.045,0-0.082,0.037-0.082,0.082v2.479c0,0.045,0.037,0.082,0.082,0.082h2.479c0.045,0,0.082-0.037,0.082-0.082v-2.479 c0-0.045-0.037-0.082-0.082-0.082H14.918z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.109,23.26c-0.001,0-0.001,0-0.002,0l-12.434-0.033c-0.87,0-1.58-0.709-1.58-1.582v-2.479 c0-0.873,0.71-1.582,1.582-1.582l12.436,0.033c0.87,0,1.58,0.709,1.58,1.582v2.479C66.691,22.551,65.981,23.26,65.109,23.26z M52.674,19.084c-0.043,0-0.08,0.037-0.08,0.082v2.479c0,0.046,0.036,0.082,0.082,0.082L65.11,21.76 c0.045,0,0.081-0.037,0.081-0.082v-2.479c0-0.045-0.037-0.082-0.082-0.082L52.674,19.084z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.109,31.208c-0.001,0-0.001,0-0.002,0l-12.434-0.034c-0.87,0.001-1.58-0.709-1.58-1.581v-2.479 c0-0.873,0.71-1.582,1.582-1.582l12.436,0.033c0.87,0,1.58,0.709,1.58,1.582v2.479C66.691,30.498,65.981,31.208,65.109,31.208z M52.674,27.031c-0.043,0-0.08,0.037-0.08,0.082v2.479c0,0.046,0.036,0.082,0.082,0.082l12.435,0.033 c0.045,0,0.081-0.037,0.081-0.082v-2.479c0-0.045-0.037-0.082-0.082-0.082L52.674,27.031z"
  }))));
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = "/*\n NOTE: very hacky solution to get next listview alpha styles in before it gets published\n TODO: once next version of listview is published, upgrade to that version\n*/\n.ListView-module_inventory-listview__Eygri ._react-spectrum-ListViewItem_49612 {\n  padding: var(--spectrum-global-dimension-size-75) var(--spectrum-global-dimension-size-150); }\n";
var styles$1 = {"inventory-listview":"ListView-module_inventory-listview__Eygri"};
styleInject(css_248z$1);

var _excluded$3 = ["children"];

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$a(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var messages$j = defineMessages({
  selectItems: {
    id: 'selectionRail.selectItems',
    defaultMessage: 'Select items'
  },
  selectedList: {
    id: 'selectionRail.selectedList',
    defaultMessage: 'Selected items'
  }
});
var SelectionRailContext = /*#__PURE__*/React.createContext(null);
/** @hidden */

function SelectionRailContextProvider(props) {
  var children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded$3);

  return /*#__PURE__*/React.createElement(SelectionRailContext.Provider, {
    value: _objectSpread$a({}, otherProps)
  }, children);
}
function SelectionRail(props) {
  var children = props.children,
      getKey = props.getKey,
      _props$width = props.width,
      width = _props$width === void 0 ? '256px' : _props$width; // contexts

  var dialogContainer = useDialogContext();

  var _useDialogContext = useDialogContext(),
      setIsSelectionRail = _useDialogContext.setIsSelectionRail,
      setModalSelectionCount = _useDialogContext.setModalSelectionCount;

  var _useInventoryContext = useInventoryContext(),
      filterState = _useInventoryContext.filterState,
      items = _useInventoryContext.items,
      onSelectionChange = _useInventoryContext.onSelectionChange,
      selectedKeys = _useInventoryContext.selectedKeys,
      selection = _useInventoryContext.selection,
      setSelection = _useInventoryContext.setSelection;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage; // state


  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedItems = _useState2[0],
      setSelectedItems = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      getContext = _useState4[0],
      setGetContext = _useState4[1];

  if (!dialogContainer) {
    return null;
  }

  var currFilterState = useCallback(function () {
    return function (filterState) {
      return filterState;
    };
  }, []);
  /** Clear all */

  // replace 'list' variable after ListView update is released
  // so renderEmptyState doesn't crop the placeholder oddly
  // const renderEmptyState = () => (
  //   <IllustratedMessage>
  //     <SelectItemsSVG/>
  //     <Heading>{formatMessage(messages.selectItems)}</Heading>
  //   </IllustratedMessage>
  // );
  var list = selectedItems.length > 0 ? /*#__PURE__*/React.createElement(ListView$1, {
    "aria-label": formatMessage(messages$j.selectedList),
    UNSAFE_className: styles$1['inventory-listview'],
    UNSAFE_style: {
      boxSizing: 'border-box'
    },
    flexGrow: 1,
    height: "100%",
    items: selectedItems
  }, typeof children === 'function' ? function (item) {
    return children(item.item, item.context);
  } : children) : /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundColor: 'white',
      height: '100%',
      stroke: 'none'
    }
  }, /*#__PURE__*/React.createElement(IllustratedMessage, null, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "center",
    alignContent: "center",
    direction: "column"
  }, /*#__PURE__*/React.createElement(SelectedItemsSVG, null), /*#__PURE__*/React.createElement(Heading, null, formatMessage(messages$j.selectItems)))));
  useEffect(function () {
    setGetContext(currFilterState);
  }, [currFilterState]);
  useEffect(function () {
    var newSelectedItems = selection === 'all' ? _toConsumableArray(items) : items.filter(function (item) {
      return new Set(selection).has(getKey(item));
    });

    var currSelectedItems = _toConsumableArray(selectedItems).map(function (item) {
      return item.item;
    });

    var currFilterState = getContext ? getContext(filterState) : {}; // select all in folder view (which should only add items in current view)

    if (selection === 'all') {
      // handle select all when folders are involved
      var filteredKeys = [].concat(_toConsumableArray(_toConsumableArray(currSelectedItems).map(function (item) {
        return getKey(item);
      })), _toConsumableArray(_toConsumableArray(items).map(function (item) {
        return getKey(item);
      })));
      setSelection(filteredKeys);
      return;
    } // get added/removed items


    var addedItems = newSelectedItems.filter(function (item) {
      return !currSelectedItems.find(function (currItem) {
        return getKey(item) === getKey(currItem);
      });
    });
    var remainingItems = currSelectedItems.filter(function (currItem) {
      return new Set(selection).has(getKey(currItem));
    }); // add or remove

    var newItems = remainingItems.map(function (item) {
      return {
        item: item,
        context: currFilterState
      };
    }); // handle remove all in folder view (which should only remove all items in current view)

    if (!selection.size && !addedItems.length && selectedItems.length && !selectedKeys) {
      var leftoverItems = selectedItems.filter(function (_ref) {
        var selectedItem = _ref.item;
        return !items.find(function (item) {
          return getKey(item) === getKey(selectedItem);
        });
      });
      var leftoverKeys = new Set();

      _toConsumableArray(leftoverItems).forEach(function (_ref2) {
        var item = _ref2.item;
        return leftoverKeys.add(getKey(item));
      });

      setSelectedItems(leftoverItems);
      setSelection(leftoverKeys);
      setModalSelectionCount(leftoverItems.length);
      return;
    }

    if (addedItems.length) {
      addedItems.forEach(function (item) {
        return currSelectedItems.push(item);
      });
      newItems = currSelectedItems.map(function (item) {
        var _selectedItems$find;

        return {
          item: item,
          context: ((_selectedItems$find = selectedItems.find(function (selectedItem) {
            return getKey(selectedItem.item) === getKey(item);
          })) === null || _selectedItems$find === void 0 ? void 0 : _selectedItems$find.context) || currFilterState
        };
      });
    }

    if (newItems.length) {
      setSelectedItems(newItems);
    } else if (!remainingItems.length) {
      setSelectedItems([]);
    }
  }, [selection]);
  useEffect(function () {
    setIsSelectionRail(true);
  }, []);
  return /*#__PURE__*/React.createElement(SelectionRailContextProvider, {
    getKey: getKey
  }, /*#__PURE__*/React.createElement(ToggleableRail, {
    auxViewType: AuxViewType.SELECTION_RAIL,
    borderPosition: "left",
    defaultOpen: true,
    rightHeaderAction: function handleClick() {
      setSelectedItems([]);
      onSelectionChange(new Set([]));
    },
    showMargins: false,
    width: width,
    toggleIcon: /*#__PURE__*/React.createElement(SelectBoxAll, null),
    toggleValue: getSelectionCountString(selectedItems)
  }, list));
}

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$9(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var messages$i = defineMessages({
  filters: {
    id: 'dialog.filters',
    defaultMessage: 'Filters'
  },
  apply: {
    id: 'dialog.apply',
    defaultMessage: 'Apply'
  },
  cancel: {
    id: 'dialog.cancel',
    defaultMessage: 'Cancel'
  }
});
var FilterDialogContext = /*#__PURE__*/createContext(null);
function FilterDialog(props) {
  var children = props.children,
      width = props.width;

  var _useInventoryContext = useInventoryContext(),
      useAuxView = _useInventoryContext.useAuxView,
      isAuxViewShown = _useInventoryContext.isAuxViewShown,
      toggleAuxView = _useInventoryContext.toggleAuxView;

  useEffect(function () {
    return useAuxView(AuxViewType.FILTER_DIALOG);
  }, []);
  return /*#__PURE__*/React.createElement(DialogContainer, {
    onDismiss: function onDismiss() {
      return toggleAuxView(AuxViewType.FILTER_DIALOG);
    }
  }, isAuxViewShown(AuxViewType.FILTER_DIALOG) && /*#__PURE__*/React.createElement(Dialog, {
    width: width
  }, children));
}

function Dialog(props) {
  var children = props.children,
      width = props.width;

  var _useInventoryContext2 = useInventoryContext(),
      filterState = _useInventoryContext2.filterState,
      onFilterChange = _useInventoryContext2.onFilterChange;

  var _useState = useState(filterState.filters || {}),
      _useState2 = _slicedToArray(_useState, 2),
      pendingFilters = _useState2[0],
      setPendingFilters = _useState2[1];

  var _useDialogContainer = useDialogContainer(),
      dismiss = _useDialogContainer.dismiss;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var onSubmit = function (filters) {
    return setPendingFilters(filters);
  };

  // the following block of code is grabbing the return children of the function as a child component. since there
  // will be only 1 child, it will look at its children to try and find the FilterList component to pull out so that
  // it can place it at the bottom of the grid (gridArea does not work if the child is immediate to the grid)
  var filterList;
  var content = [];
  var dialogChildren = children({
    filters: pendingFilters,
    onFilterChange: function onCustomFilterChange(key, value) {
      var newTentativeFilters = _objectSpread$9(_objectSpread$9({}, pendingFilters), {}, _defineProperty({}, key, value));

      if (value === null || Array.isArray(value) && !value.length || _typeof(value) === 'object' && !Object.keys(value).length) {
        delete newTentativeFilters[key];
      }

      setPendingFilters(newTentativeFilters);
    },
    onSubmit: onSubmit
  });

  if (dialogChildren.props.children.length > 1) {
    dialogChildren = dialogChildren.props.children;
  }

  Children.forEach(dialogChildren, function (child) {
    if (!child) {
      return;
    }

    if (child.type === FilterList) {
      filterList = child;
    } else {
      content.push(child);
    }
  });
  return /*#__PURE__*/React.createElement(FilterDialogContext.Provider, {
    value: {
      pendingFilters: pendingFilters,
      onSubmit: onSubmit
    }
  }, /*#__PURE__*/React.createElement(Dialog$2, {
    width: width
  }, /*#__PURE__*/React.createElement(Heading, null, formatMessage(messages$i.filters)), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Content, {
    maxHeight: "420px"
  }, /*#__PURE__*/React.createElement(Grid, {
    areas: ['content', 'filterTags'],
    rows: ['1fr', 'auto'],
    height: "100%"
  }, /*#__PURE__*/React.createElement(View$1, {
    gridArea: "content",
    overflow: "scroll"
  }, content), /*#__PURE__*/React.createElement(Provider, null, filterList))), /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onPress: dismiss
  }, formatMessage(messages$i.cancel)), /*#__PURE__*/React.createElement(Button, {
    variant: "cta",
    onPress: function onApply() {
      onFilterChange('filters', pendingFilters);
      dismiss();
    }
  }, formatMessage(messages$i.apply)))));
}

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$8(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var messages$h = defineMessages({
  clearAll: {
    id: 'headers.clearAll',
    defaultMessage: 'Clear all'
  },
  filteringBy: {
    id: 'headers.filteringBy',
    defaultMessage: 'FILTERING BY'
  },
  others: {
    id: 'headers.others',
    defaultMessage: '{quantity, plural, one {other} other {others}}'
  },
  filterCount: {
    id: 'headers.filterCount',
    defaultMessage: '{quantity, plural, one {filter} other {filters}}'
  }
});
function FilterList(props) {
  var children = props.children;

  var _useInventoryContext = useInventoryContext(),
      filterState = _useInventoryContext.filterState,
      onFilterChange = _useInventoryContext.onFilterChange;

  var filterDialogContext = useContext(FilterDialogContext);

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var filters = {};
  // pending filters gets precedence since it will contain current filters
  Object.entries((filterDialogContext === null || filterDialogContext === void 0 ? void 0 : filterDialogContext.pendingFilters) || filterState.filters || {}).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        values = _ref2[1];

    // skip empty values
    if (values == null || Array.isArray(values) && !values.length || _typeof(values) === 'object' && Object.values(values).every(function (v) {
      return v == null;
    })) {
      return;
    }

    filters[key] = values;
  });
  var filterCount = Object.keys(filters).length;
  var tags = Object.entries(filters).map(function (entry) {
    return children(entry);
  }).filter(function (child) {
    return !!child;
  });

  if (!filterCount || !tags.length) {
    return null;
  }

  var label = filterDialogContext ? formatMessage(messages$h.filterCount, {
    quantity: filterCount
  }) : formatMessage(messages$h.filteringBy);
  return /*#__PURE__*/React.createElement(React.Fragment, null, filterDialogContext && /*#__PURE__*/React.createElement(Divider, {
    size: "M"
  }), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    gap: "size-125",
    gridArea: "filterTags"
  }, /*#__PURE__*/React.createElement("span", {
    id: "taglist-label"
  }, label, ":"), /*#__PURE__*/React.createElement(TagList, {
    readOnly: false,
    manageTabIndex: true,
    "aria-labelledby": "taglist-label"
  }, tags), /*#__PURE__*/React.createElement(ActionButton, {
    flexShrink: 0,
    isQuiet: true,
    onPress: function onClear() {
      filterDialogContext ? filterDialogContext.onSubmit({}) : onFilterChange('filters', {});
    }
  }, formatMessage(messages$h.clearAll))));
}
/** @hidden */

function FilterTag(props) {
  var children = props.children,
      icon = props.icon,
      label = props.label,
      _props$maxVisibleValu = props.maxVisibleValues,
      maxVisibleValues = _props$maxVisibleValu === void 0 ? 2 : _props$maxVisibleValu,
      value = props.value;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var tagValues = React.Children.map(children, function (c) {
    return {
      label: c.props.label || c.props.value,
      value: c.props.value
    };
  });

  var _useIntl2 = useIntl(),
      formatMessage = _useIntl2.formatMessage;

  var _useInventoryContext2 = useInventoryContext(),
      filterState = _useInventoryContext2.filterState,
      onFilterChange = _useInventoryContext2.onFilterChange;

  var filterDialogContext = useContext(FilterDialogContext);

  if (expanded) {
    return /*#__PURE__*/React.createElement(Flex, {
      UNSAFE_style: {
        display: 'inline-block'
      },
      justifyContent: "center",
      alignItems: "center",
      gap: "size-125"
    }, /*#__PURE__*/React.createElement("span", null, label || value, ":"), /*#__PURE__*/React.createElement(TagList, {
      onClose: function onTagClose(tag) {
        var _newFiltersState$valu;

        var newFiltersState = filterDialogContext ? _objectSpread$8({}, filterDialogContext.pendingFilters) : _objectSpread$8({}, filterState.filters);
        var tagIndex = (_newFiltersState$valu = newFiltersState[value]) === null || _newFiltersState$valu === void 0 ? void 0 : _newFiltersState$valu.findIndex(function (t) {
          return t === tag;
        });

        if (tagIndex > -1) {
          // create new copy of array so that splice doesn't affect the current filterState
          newFiltersState[value] = _toConsumableArray(newFiltersState[value]);
          newFiltersState[value].splice(tagIndex, 1);
          filterDialogContext ? filterDialogContext.onSubmit(newFiltersState) : onFilterChange('filters', newFiltersState);
        }
      }
    }, tagValues.map(function (tagValue) {
      return /*#__PURE__*/React.createElement(Tag, {
        key: tagValue.value,
        closable: true,
        value: tagValue.value
      }, tagValue.label);
    })), /*#__PURE__*/React.createElement(ActionButton, {
      isQuiet: true,
      onPress: function onPress() {
        return setExpanded(false);
      }
    }, "Collapse"));
  }

  var hiddenValues,
      showValues = tagValues.map(function (tagValue) {
    return tagValue.label;
  });

  if (tagValues.length > maxVisibleValues) {
    showValues = tagValues.slice(0, maxVisibleValues).map(function (tagValue) {
      return tagValue.label;
    });
    hiddenValues = tagValues.slice(maxVisibleValues).map(function (tagValue) {
      return tagValue.label;
    });
    showValues.push(''); // push empty string so that trailing comma will be there for the bolded others text
  }

  var onClose = function (tag) {
    var newFiltersState = filterDialogContext ? _objectSpread$8({}, filterDialogContext.pendingFilters) : _objectSpread$8({}, filterState.filters);
    delete newFiltersState[tag];
    filterDialogContext ? filterDialogContext.onSubmit(newFiltersState) : onFilterChange('filters', newFiltersState);
  };

  var tag = /*#__PURE__*/React.createElement(Tag, {
    key: value,
    closable: true,
    value: value,
    onClose: onClose,
    onClick: function onExpand() {
      return tagValues.length > 1 && setExpanded(true);
    }
  }, icon ? icon : label || value, ": ", showValues.join(', '), !!hiddenValues && /*#__PURE__*/React.createElement("b", null, "+", hiddenValues.length, " ", formatMessage(messages$h.others, {
    quantity: hiddenValues.length
  }))); // generate tooltip showing all values

  if (hiddenValues) {
    tag = /*#__PURE__*/React.createElement(OverlayTrigger, {
      delay: TOOLTIP_DELAY,
      placement: "top"
    }, tag, /*#__PURE__*/React.createElement(Tooltip$1, null, tagValues.map(function (tagValue) {
      return tagValue.label;
    }).join(', ')));
  }

  return tag;
}

/*
NOTE: this exported component doesn't return an element as its parent (FilterTag) will pull off the props in order
      to combine the values into a single string list

current api:
  <FilterList>
    <FilterTag icon={} label={} value={}>
      <FilterValue label={} value=[} />
    </FilterTag>
  </FilterList>
*/
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function FilterValue() {
  return null;
}

function useLayoutProps(props) {
  var _useInventoryContext = useInventoryContext(),
      layout = _useInventoryContext.layout;

  var layoutProps = layout ? props[layout] : props["default"];
  return layoutProps || {};
}

var messages$g = defineMessages({
  search: {
    id: 'headers.search',
    defaultMessage: 'Search'
  }
});
// timeout variable for debounce
var timeout;
var allLayoutProps = {
  rail: {
    width: '100%'
  },
  "default": {
    gridArea: 'search',
    flexGrow: 0
  }
};
function Search(props) {
  var autoFocus = props.autoFocus,
      placeholder = props.placeholder,
      wait = props.wait,
      _props$width = props.width,
      width = _props$width === void 0 ? 240 : _props$width;

  var _useInventoryContext = useInventoryContext(),
      filterState = _useInventoryContext.filterState,
      onFilterChange = _useInventoryContext.onFilterChange;

  var _useState = useState(filterState.query || ''),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  useEffect(function () {
    // if inventory clears out query due to folder navigation, clear out the state value
    if (filterState.query !== value) {
      setValue(filterState.query || '');
    }
  }, [filterState.query]);

  var onChange = function (searchValue) {
    setValue(searchValue);

    if (!wait) {
      return onFilterChange('query', searchValue);
    }

    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(function () {
      onFilterChange('query', searchValue);
    }, wait);
  };

  var layoutProps = useLayoutProps(allLayoutProps);
  return /*#__PURE__*/React.createElement(SearchField, _extends({
    autoFocus: autoFocus,
    "aria-label": formatMessage(messages$g.search),
    onChange: onChange,
    value: value,
    placeholder: placeholder || formatMessage(messages$g.search),
    width: width
  }, layoutProps));
}

var messages$f = defineMessages({
  showFilters: {
    id: 'headers.showFilters',
    defaultMessage: 'Show filters'
  },
  openFilters: {
    id: 'headers.openFilters',
    defaultMessage: 'Open filters'
  }
});
var ViewHeader = function (props) {
  var children = props.children;

  var _useInventoryContext = useInventoryContext(),
      getAuxViewToggleCount = _useInventoryContext.getAuxViewToggleCount,
      isAuxViewEnabled = _useInventoryContext.isAuxViewEnabled,
      isAuxViewShown = _useInventoryContext.isAuxViewShown,
      toggleAuxView = _useInventoryContext.toggleAuxView;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var hasFilterDialog = isAuxViewEnabled(AuxViewType.FILTER_DIALOG);
  // special placement for search and filter list
  var search, filterList;
  var body = [];
  Children.forEach(children, function (child) {
    if (!child) {
      return;
    }

    switch (child.type) {
      case Search:
        search = child;
        break;

      case FilterList:
        filterList = child;
        break;

      default:
        body.push(child);
    }
  });
  var showFilterToggle = isAuxViewEnabled(AuxViewType.FILTER_RAIL) && !isAuxViewShown(AuxViewType.FILTER_RAIL) || hasFilterDialog;
  return /*#__PURE__*/React.createElement(Header$1, {
    minHeight: "size-400"
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    width: "100%",
    rowGap: "size-40"
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: "size-100",
    width: "100%",
    minHeight: "size-400"
  }, showFilterToggle && /*#__PURE__*/React.createElement(View$1, {
    gridArea: "toggle"
  }, /*#__PURE__*/React.createElement(TooltipTrigger, {
    delay: TOOLTIP_DELAY
  }, /*#__PURE__*/React.createElement(ActionButton, {
    "aria-label": formatMessage(hasFilterDialog ? messages$f.openFilters : messages$f.showFilters),
    isQuiet: true,
    autoFocus: getAuxViewToggleCount(AuxViewType.FILTER_RAIL) > 0,
    onPress: function onFilterPress() {
      if (hasFilterDialog) {
        toggleAuxView(AuxViewType.FILTER_DIALOG);
      } else {
        toggleAuxView(AuxViewType.FILTER_RAIL);
      }
    }
  }, /*#__PURE__*/React.createElement(Filter, null)), /*#__PURE__*/React.createElement(Tooltip, null, formatMessage(hasFilterDialog ? messages$f.openFilters : messages$f.showFilters)))), search, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    flexGrow: 1
  }, body)), filterList));
};

/** @hidden */

function DefaultLayout(props) {
  var children = props.children,
      height = props.height;

  var _useComponentContext = useComponentContext(),
      components = _useComponentContext.components;

  var header, folderRail, filterRail, viewHeader, pagination, selectionRail;
  var body = [];
  Children.forEach(children, function (child) {
    if (!child) {
      return;
    }

    switch (child.type) {
      case PageHeader:
        header = child;
        break;

      case FolderRail:
        folderRail = child;
        break;

      case FilterRail:
        filterRail = child;
        break;

      case ViewHeader:
        viewHeader = child;
        break;

      case Pagination:
        pagination = child;
        break;

      case SelectionRail:
        selectionRail = child;
        break;

      default:
        body.push(child);
    }
  });
  return /*#__PURE__*/React.createElement(Grid, {
    areas: ['folderRail pageHeader pageHeader selectionRail', 'folderRail filterRail viewHeader selectionRail', 'folderRail filterRail content selectionRail', 'folderRail filterRail pagination selectionRail'],
    height: height,
    columns: ['auto', 'auto', '1fr', 'auto'],
    rows: ['auto', 'auto', '1fr', 'auto', 'auto']
  }, folderRail && /*#__PURE__*/React.createElement(View$1, {
    gridArea: "folderRail",
    height: "100%"
  }, folderRail), header && /*#__PURE__*/React.createElement(View$1, {
    gridArea: "pageHeader",
    paddingX: "size-100"
  }, header), filterRail && /*#__PURE__*/React.createElement(View$1, {
    gridArea: "filterRail",
    height: "100%"
  }, filterRail), selectionRail && /*#__PURE__*/React.createElement(View$1, {
    gridArea: "selectionRail",
    height: "100%"
  }, selectionRail), viewHeader && /*#__PURE__*/React.createElement(View$1, {
    gridArea: "viewHeader",
    paddingX: "size-100",
    paddingTop: "size-150"
  }, viewHeader), /*#__PURE__*/React.createElement(View$1, {
    gridArea: "content",
    paddingX: "size-100",
    minHeight: 0,
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement("div", {
    role: "region",
    "aria-live": "polite",
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement(ActionBarContainer, {
    height: "100%"
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    height: "100%"
  }, body), components[ComponentType.BULK_ACTION_BAR]))), pagination && /*#__PURE__*/React.createElement(View$1, {
    gridArea: "pagination",
    paddingX: "size-100"
  }, pagination));
}

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$7(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @hidden
 * Merge filter state (quickFilters -> filters) for consumers
 */
function mergeFilterState(state) {
  var newState = _objectSpread$7(_objectSpread$7({}, state), {}, {
    filters: _objectSpread$7(_objectSpread$7({}, state.filters), state.quickFilters)
  });

  delete newState.quickFilters;

  if (isNull(newState.filters)) {
    delete newState.filters;
  }

  return newState;
}
/**
 * @hidden
 * Checks if a filter value is null (or any empty array/object)
 */

function isNull(value) {
  return value == null || Array.isArray(value) && !value.length || _typeof(value) === 'object' && !Object.keys(value).length;
}

var name = "@quarry/inventory";
var version = "1.0.0-beta.6";
var description = "Inventory component";
var main = "lib/index.cjs.js";
var module = "lib/index.esm.js";
var source = "src/index.ts";
var types = "lib/index.d.ts";
var files = [
	"src",
	"lib"
];
var scripts = {
	build: "npm-run-all --npm-path npm --parallel --aggregate-output build:src build:defs",
	"build:src": "quarry-scripts rollup -c rollup.config.js",
	"build:defs": "quarry-scripts tsc --declaration --emitDeclarationOnly -p .",
	"build:watch": "yarn build:src -w",
	prepack: "cross-env NODE_ENV=production npm-run-all --npm-path npm build",
	lint: "npm-run-all --npm-path npm --parallel --aggregate-output lint:eslint",
	"lint:eslint": "quarry-scripts eslint src --ext js,ts,tsx",
	storybook: "quarry-scripts storybook -p 12345",
	start: "yarn storybook",
	test: "quarry-scripts jest --collect-coverage",
	"test:watch": "yarn test --watch",
	localize: "yarn harvest && yarn aladdin:put && yarn aladdin:get",
	harvest: "babel-node adobe-intl-scripts/harvest.js",
	"aladdin:put": "babel-node adobe-intl-scripts/aladdin.js --command put",
	"aladdin:get": "babel-node adobe-intl-scripts/aladdin.js --command get"
};
var repository = {
	type: "git",
	url: "https://git.corp.adobe.com/frontend/quarry"
};
var keywords = [
	"ui",
	"component",
	"react",
	"inventory",
	"rail"
];
var author = "Adobe";
var license = "UNLICENSED";
var peerDependencies = {
	"@adobe/react-spectrum": ">= 3.14",
	"@react/react-spectrum": ">= 2.28",
	react: ">= 16.8",
	"react-dom": ">= 16.8",
	"react-intl": ">=5.8.4"
};
var peerDependenciesMeta = {
	"@react/react-spectrum": {
		optional: true
	}
};
var dependencies = {
	"@quarry/eim-provider": "^1.2.0",
	"@quarry/header": "^1.0.0-alpha.16",
	"@quarry/intl": "^1.0.3",
	"@react-aria/dnd": "3.0.0-alpha.3",
	"@react-spectrum/actionbar": "3.0.0-alpha.3",
	"@react-spectrum/list": "3.0.0-alpha.2",
	"@react-stately/dnd": "3.0.0-alpha.2",
	"@spectrum-icons/illustrations": "^3.0.0",
	"@spectrum-icons/workflow": "^3.0.0"
};
var devDependencies = {
	"@adobe/react-spectrum": "^3.14.0",
	"@babel/plugin-transform-runtime": "^7.15.0",
	"@quarry/quarry-scripts": "^1.4.0",
	"@react/react-spectrum": "^2.28.0",
	"@testing-library/jest-dom": "^5.11.2",
	"@testing-library/react": "^10.4.5",
	"@testing-library/react-hooks": "3.4.1",
	"@types/enzyme": "^3.10.3",
	"@types/jest": "^24.0.18",
	"@types/storybook__react": "^4.0.2",
	enzyme: "^3.10.0",
	"enzyme-adapter-react-16": "^1.14.0",
	"react-intl": "^5.8.4",
	"regenerator-runtime": "^0.13.3"
};
var gitHead = "b4d55f823d3f4f98638d9ebac210a85fb3571265";
var packageJson = {
	name: name,
	version: version,
	description: description,
	main: main,
	module: module,
	source: source,
	types: types,
	files: files,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	peerDependencies: peerDependencies,
	peerDependenciesMeta: peerDependenciesMeta,
	dependencies: dependencies,
	devDependencies: devDependencies,
	gitHead: gitHead
};

function RailHeader(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement(Grid, {
    gridArea: "railHeader",
    autoFlow: "row",
    width: "100%",
    rowGap: "size-100"
  }, children);
}

/** @hidden */

function RailLayout(props) {
  var children = props.children,
      _props$height = props.height,
      height = _props$height === void 0 ? '100%' : _props$height,
      _props$width = props.width,
      width = _props$width === void 0 ? '256px' : _props$width;
  var railHeader;
  var body = [];
  Children.forEach(children, function (child) {
    if (!child) {
      return;
    }

    switch (child.type) {
      case RailHeader:
        railHeader = child;
        break;

      default:
        body.push(child);
    }
  });

  if (railHeader) {
    return /*#__PURE__*/React.createElement(Grid, {
      areas: ['railHeader', 'divider', 'content'],
      rows: ['auto', 'auto', '1fr'],
      width: width,
      height: height
    }, railHeader, /*#__PURE__*/React.createElement(Divider, {
      size: "M",
      gridArea: "divider",
      marginY: "size-100"
    }), /*#__PURE__*/React.createElement(View$1, {
      gridArea: "content"
    }, body));
  }

  return /*#__PURE__*/React.createElement(Grid, {
    height: height,
    width: width,
    autoFlow: "row",
    rowGap: "size-100"
  }, children);
}

/** @hidden */

function FolderEmpty() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    enableBackground: "new 0 0 96 96",
    height: "110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder_open_lg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder_open_lg-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B3B4B4",
    d: "M12.4,75.5c-0.4,0-0.9-0.1-1.4-0.2c-2.1-0.6-3.5-2.6-3.4-4.7V23c0-3.4,2.8-6.2,6.2-6.2h18.4 c1.5,0,3,0.6,4.1,1.7l6.5,6.7c0.1,0.1,0.3,0.2,0.4,0.2h26.2c3.4,0,6.2,2.8,6.2,6.2v3.7c0,0.8-0.7,1.5-1.5,1.5s-1.5-0.7-1.5-1.5 v-3.7c0-1.8-1.4-3.2-3.2-3.2H43.3c-1,0-1.9-0.4-2.6-1.1l-6.5-6.7c-0.5-0.5-1.2-0.8-1.9-0.8H13.9c-1.8,0-3.2,1.4-3.2,3.2v47.6 c0,0.8,0.5,1.6,1.3,1.8c0.9,0.3,1.9-0.2,2.2-1.2l8.7-28.1c1-3.1,3.8-5.2,7.1-5.2h55.2c0.7,0,1.4,0.1,2,0.4c3,1.1,4.5,4.5,3.4,7.5 l-9.1,24.9c-1,2.8-3.8,4.8-6.8,4.8H19.3c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h55.3c1.8,0,3.4-1.1,4-2.8l9.1-24.9 c0.5-1.5-0.2-3.1-1.7-3.6c-0.3-0.1-0.6-0.2-1-0.2H29.9c-2,0-3.6,1.3-4.2,3.1L17,72.2C16.3,74.2,14.5,75.5,12.4,75.5z"
  }))));
}
/** @hidden */

function NotFound() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    enableBackground: "new 0 0 96 96",
    height: "110"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B3B4B4",
    d: "M80.9,70.3L62.3,51.6c-0.8-0.8-2-0.8-2.9-0.2l-1-1c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l1,1l-1.8,1.8l-1-1 c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l1,1c-0.7,0.9-0.7,2.2,0.1,3l18.6,18.6c1,1,2.4,1.5,3.7,1.5c1.3,0,2.7-0.5,3.7-1.5 C83,75.6,83,72.3,80.9,70.3z M78.8,75.6c-0.9,0.9-2.3,0.9-3.2,0L57.5,57.5l3.2-3.2l18.1,18.1C79.7,73.3,79.7,74.7,78.8,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B4B4",
    d: "M61,56.8c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l9.3,9.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3 c0.4-0.4,0.4-1,0-1.4L61,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B4B4",
    d: "M61.6,39.2c0.9-5.7-0.5-11.5-4-16.1c-4.1-5.5-10.6-8.9-17.5-8.9c-7.9,0-15.2,4-18.6,10.2 c-0.4,0.7-0.1,1.6,0.6,2s1.6,0.1,2-0.6c2.9-5.2,9.1-8.6,16-8.6c5.9,0,11.6,2.9,15.1,7.6c3,4,4.2,9,3.4,13.9s-3.4,9.3-7.4,12.2 c-4,3-9,4.2-13.9,3.4s-9.3-3.4-12.2-7.4c-0.5-0.7-1.4-0.8-2.1-0.3s-0.8,1.4-0.3,2.1c3.4,4.7,8.5,7.7,14.2,8.6 c1.1,0.2,2.2,0.3,3.3,0.3c4.6,0,9-1.4,12.8-4.2C57.7,50,60.8,44.9,61.6,39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B4B4",
    d: "M25.9,42.8c0.3,0.3,0.7,0.4,1.1,0.4s0.8-0.1,1.1-0.4c0.6-0.6,0.6-1.5,0-2.1l-4.4-4.4l4.4-4.4 c0.6-0.6,0.6-1.5,0-2.1s-1.5-0.6-2.1,0l-4.4,4.4l-4.4-4.4c-0.6-0.6-1.5-0.6-2.1,0s-0.6,1.5,0,2.1l4.4,4.4L15,40.7 c-0.6,0.6-0.6,1.5,0,2.1c0.3,0.3,0.7,0.4,1.1,0.4c0.4,0,0.8-0.1,1.1-0.4l4.4-4.4L25.9,42.8z"
  })));
}

var messages$e = defineMessages({
  noResults: {
    id: 'emptyState.noResultsFound',
    defaultMessage: 'No results found'
  },
  modifyCriteria: {
    id: 'emptyState.modifyCriteria',
    defaultMessage: 'For better results, modify your criteria'
  },
  emptyFolder: {
    id: 'emptyState.emptyFolder',
    defaultMessage: 'You have nothing in your folder'
  },
  emptyFolderActions: {
    id: 'emptyState.emptyFolderActions',
    defaultMessage: 'Return to the previous folder or create new'
  },
  emptyLibrary: {
    id: 'emptyState.emptyLibrary',
    defaultMessage: 'You have nothing in your library'
  },
  libraryFiles: {
    id: 'emptyState.libraryFiles',
    defaultMessage: 'When there are files added, they will show up here'
  }
});
/** @hidden */

function DefaultEmptyState() {
  var _useInventoryContext = useInventoryContext(),
      filterState = _useInventoryContext.filterState;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var illustration, heading, content;

  if (filterState.query || Object.keys(filterState.filters || filterState.quickFilters || {}).length) {
    illustration = /*#__PURE__*/React.createElement(NotFound, null);
    heading = formatMessage(messages$e.noResults);
    content = formatMessage(messages$e.modifyCriteria);
  } else if (filterState.folder) {
    illustration = /*#__PURE__*/React.createElement(FolderEmpty, null);
    heading = formatMessage(messages$e.emptyFolder);
    content = formatMessage(messages$e.emptyFolderActions);
  } else {
    illustration = /*#__PURE__*/React.createElement(FolderEmpty, null);
    heading = formatMessage(messages$e.emptyLibrary);
    content = formatMessage(messages$e.libraryFiles);
  }

  return /*#__PURE__*/React.createElement(IllustratedMessage$1, null, illustration, /*#__PURE__*/React.createElement(Heading$1, null, heading), /*#__PURE__*/React.createElement(Content$1, null, content));
}

function renderEmptyState() {
  return /*#__PURE__*/React.createElement(DefaultEmptyState, null);
}

function diffObjs(oldObj, newObj) {
  var oldKeys = Object.keys(oldObj);
  var newKeys = Object.keys(newObj);
  var added = [];
  var unchanged = [];
  var removed = oldKeys.filter(function (key) {
    return !newKeys.includes(key);
  });
  newKeys.filter(function (key) {
    if (!oldKeys.includes(key)) {
      added.push(key);
    } else {
      unchanged.push(key);
    }
  });
  return {
    added: added,
    unchanged: unchanged,
    removed: removed
  };
}
/** @hidden */


function generateFilterEvent(oldFilterState, newFilterState) {
  var keys = [];

  var _diffObjs = diffObjs(oldFilterState, newFilterState),
      addedKeys = _diffObjs.added,
      removedKeys = _diffObjs.removed,
      unchangedKeys = _diffObjs.unchanged;

  addedKeys.forEach(function (key) {
    return keys.push({
      key: key,
      oldValue: null
    });
  });
  removedKeys.forEach(function (key) {
    return keys.push({
      key: key,
      oldValue: oldFilterState[key]
    });
  });
  unchangedKeys.forEach(function (key) {
    // check for differences in same keys
    var oldValue = oldFilterState[key];
    var newValue = newFilterState[key];

    if (_typeof(oldValue) !== 'object' && _typeof(newValue) !== 'object' && oldValue !== newValue) {
      keys.push({
        key: key,
        oldValue: oldValue
      });
    } // handle filters, sortDescriptor fields (and other object fields


    if (_typeof(oldValue) === 'object' && _typeof(newValue) === 'object') {
      var _diffObjs2 = diffObjs(oldValue, newValue),
          added = _diffObjs2.added,
          removed = _diffObjs2.removed,
          unchanged = _diffObjs2.unchanged;

      added.forEach(function (addedKey) {
        return keys.push({
          key: "".concat(key, ".").concat(addedKey),
          oldValue: null
        });
      });
      removed.forEach(function (removedKey) {
        return keys.push({
          key: "".concat(key, ".").concat(removedKey),
          oldValue: oldFilterState[key][removedKey]
        });
      });
      unchanged.forEach(function (unchangedKey) {
        if (oldFilterState[key][unchangedKey] !== newFilterState[key][unchangedKey]) {
          keys.push({
            key: "".concat(key, ".").concat(unchangedKey),
            oldValue: oldFilterState[key][unchangedKey]
          });
        }
      });
    }
  });
  return {
    keys: keys
  };
}

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function Inventory(props) {
  var children = props.children,
      defaultSelectedFilters = props.defaultSelectedFilters,
      defaultSelectedKeys = props.defaultSelectedKeys,
      defaultSelectedViewSettings = props.defaultSelectedViewSettings,
      disabledKeys = props.disabledKeys,
      height = props.height,
      items = props.items,
      layout = props.layout,
      loadingState = props.loadingState,
      locale = props.locale,
      onLoadMore = props.onLoadMore,
      pagination = props.pagination,
      selectedKeys = props.selectedKeys,
      _props$selectionMode = props.selectionMode,
      selectionMode = _props$selectionMode === void 0 ? 'none' : _props$selectionMode,
      _props$sortOptions = props.sortOptions,
      sortOptions = _props$sortOptions === void 0 ? [] : _props$sortOptions,
      width = props.width;
  var id = useId();
  var modalContext = useDialogContext(); // modal
  // initial aux view state based on default view settings

  var initialAuxViewState = {};
  useAdoption({
    name: packageJson.name,
    version: packageJson.version
  });
  useEffect(function () {
    if (modalContext) {
      var selectionCount = selectedKeys === 'all' || defaultSelectedKeys === 'all' ? 'all' : Array.from(selectedKeys || defaultSelectedKeys || []).length;
      modalContext.setModalSelectionCount(selectionCount);
    }

    Object.keys(AuxViewType).filter(function (k) {
      return !isNaN(Number(k));
    }).forEach(function (enumVal) {
      var _defaultSelectedViewS, _defaultSelectedViewS2;

      initialAuxViewState[enumVal] = {
        show: (_defaultSelectedViewS = defaultSelectedViewSettings === null || defaultSelectedViewSettings === void 0 ? void 0 : (_defaultSelectedViewS2 = defaultSelectedViewSettings.openedRails) === null || _defaultSelectedViewS2 === void 0 ? void 0 : _defaultSelectedViewS2.includes(AuxViewRail[enumVal])) !== null && _defaultSelectedViewS !== void 0 ? _defaultSelectedViewS : false,
        enabled: false,
        toggleCount: 0
      };
    });
  }, []); // state

  var _useState = useState(defaultSelectedFilters || {}),
      _useState2 = _slicedToArray(_useState, 2),
      filterState = _useState2[0],
      setFilterState = _useState2[1];

  var _useState3 = useState(new Set()),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedViewLabel = _useState4[0],
      setSelectedViewLabel = _useState4[1];

  var _useState5 = useState(defaultSelectedViewSettings || {}),
      _useState6 = _slicedToArray(_useState5, 2),
      viewSettings = _useState6[0],
      setViewSettings = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      tableColumns = _useState8[0],
      setTableColumns = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      currentPath = _useState10[0],
      setCurrentPath = _useState10[1];

  var _useState11 = useState(initialAuxViewState),
      _useState12 = _slicedToArray(_useState11, 2),
      auxViewState = _useState12[0],
      setAuxViewState = _useState12[1];

  var _useState13 = useState(sortOptions.find(function (option) {
    return option.direction != null;
  })),
      _useState14 = _slicedToArray(_useState13, 2),
      selectedSort = _useState14[0],
      setSelectedSort = _useState14[1];

  var _useState15 = useState(defaultSelectedKeys || new Set([])),
      _useState16 = _slicedToArray(_useState15, 2),
      selection = _useState16[0],
      setSelection = _useState16[1];

  useEffect(function () {
    // if selectedKeys are changed (controlled selection), update internal selection state to match
    if (selectedKeys) {
      setSelection(selectedKeys);

      if (modalContext) {
        modalContext.setModalSelectionCount(selectedKeys === 'all' ? 'all' : new Set(selectedKeys).size);
      }
    }
  }, [selectedKeys]);

  var onSelectionChange = function (newSelectedKeys) {
    // set selection if not in controlled state
    if (!selectedKeys) {
      setSelection(newSelectedKeys);

      if (modalContext) {
        var newKeys = selectedKeys !== null && selectedKeys !== void 0 ? selectedKeys : newSelectedKeys;
        modalContext.setModalSelectionCount(newKeys === 'all' ? 'all' : newKeys.size);
      }
    }

    props.onSelectionChange && props.onSelectionChange(newSelectedKeys);
  };

  // adapt auxViewState to viewSettings callback
  var formatAuxViewSettings = function (state) {
    var openedRails = [];
    var hasRails = false;
    Object.keys(AuxViewRail).filter(function (k) {
      return isNaN(Number(k));
    }).forEach(function (enumKey) {
      if (state[AuxViewRail[enumKey]].enabled) {
        hasRails = true;
      }

      if (state[AuxViewRail[enumKey]].show) {
        openedRails.push(enumKey);
      }
    }); // only report openedRails if inventory instance has a rail configured

    return hasRails ? {
      openedRails: openedRails
    } : {};
  };

  // determine layout
  var layoutComponent;

  switch (layout) {
    case 'rail':
      layoutComponent = /*#__PURE__*/React.createElement(RailLayout, {
        height: height,
        width: width
      }, children);
      break;

    default:
      layoutComponent = /*#__PURE__*/React.createElement(DefaultLayout, {
        height: height
      }, children);
  }

  return /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale,
    messages: localizationMessages
  }, /*#__PURE__*/React.createElement(ComponentProvider, null, /*#__PURE__*/React.createElement(InventoryContextProvider, {
    id: id,
    currentPath: currentPath,
    disabledKeys: disabledKeys,
    filterState: filterState,
    getAuxViewToggleCount: function getAuxViewToggleCount(auxViewKey) {
      var _auxViewState$auxView3;

      return (_auxViewState$auxView3 = auxViewState[auxViewKey]) === null || _auxViewState$auxView3 === void 0 ? void 0 : _auxViewState$auxView3.toggleCount;
    },
    isAuxViewEnabled: function isAuxViewEnabled(auxViewKey) {
      var _auxViewState$auxView;

      return (_auxViewState$auxView = auxViewState[auxViewKey]) === null || _auxViewState$auxView === void 0 ? void 0 : _auxViewState$auxView.enabled;
    },
    isAuxViewShown: function isAuxViewShown(auxViewKey) {
      var _auxViewState$auxView2;

      return (_auxViewState$auxView2 = auxViewState[auxViewKey]) === null || _auxViewState$auxView2 === void 0 ? void 0 : _auxViewState$auxView2.show;
    },
    loadingState: loadingState,
    items: items,
    layout: layout,
    onFilterChange: function onFilterChange(filterKey, filterValue, options) {
      var newFilterState = _objectSpread$6(_objectSpread$6({}, filterState), {}, _defineProperty({}, filterKey, filterValue)); // remove filter value if value is null or empty


      if (isNull(filterValue)) {
        delete newFilterState[filterKey];
      } // clear query/filters if `isFolderNavigate` option set


      if (options !== null && options !== void 0 && options.isFolderNavigate) {
        delete newFilterState.filters;
        delete newFilterState.query; // clear selection when navigating folders (future selection rail should maintain selection)

        if (!(modalContext !== null && modalContext !== void 0 && modalContext.isSelectionRail)) {
          onSelectionChange(new Set([]));
        }
      }

      props.onFilterChange && props.onFilterChange(mergeFilterState(newFilterState), generateFilterEvent(mergeFilterState(filterState), mergeFilterState(newFilterState)));
      setFilterState(newFilterState);
    },
    onLoadMore: onLoadMore,
    onSelectionChange: onSelectionChange,
    onViewSelect: function onViewSelect(viewLabel) {
      var viewLabelSet = new Set(viewLabel);

      if (typeof viewLabel === 'string') {
        viewLabelSet = new Set([viewLabel]);
      }

      setSelectedViewLabel(viewLabelSet);
    },
    onViewSettingChange: function onViewSettingChange(settingKey, settingValue) {
      var newViewSettings = _objectSpread$6(_objectSpread$6({}, viewSettings), {}, _defineProperty({}, settingKey, settingValue));

      props.onViewSettingChange && props.onViewSettingChange(_objectSpread$6(_objectSpread$6({}, newViewSettings), formatAuxViewSettings(auxViewState)), {
        key: settingKey
      });
      setViewSettings(newViewSettings);
    },
    pagination: pagination,
    renderEmptyState: function renderEmptyState$1() {
      var _props$renderEmptySta;

      var renderer = (_props$renderEmptySta = props.renderEmptyState) !== null && _props$renderEmptySta !== void 0 ? _props$renderEmptySta : renderEmptyState;
      return renderer(filterState);
    },
    selectedKeys: selectedKeys,
    selectedSort: selectedSort,
    selection: selection,
    selectionMode: selectionMode,
    setPath: function setPath(path) {
      setCurrentPath(path);
      setFilterState(_objectSpread$6(_objectSpread$6({}, filterState), {}, {
        folder: (path === null || path === void 0 ? void 0 : path.length) > 0 ? path[path.length - 1].key : null
      }));
    },
    setSelectedSort: setSelectedSort,
    setSelection: setSelection,
    setTableColumns: setTableColumns,
    selectedViewLabel: selectedViewLabel,
    sortOptions: sortOptions,
    tableColumns: tableColumns,
    toggleAuxView: function toggleAuxView(auxViewKey) {
      var newAuxViewState = _objectSpread$6({}, auxViewState);

      newAuxViewState[auxViewKey].show = !newAuxViewState[auxViewKey].show;
      newAuxViewState[auxViewKey].toggleCount++;
      props.onViewSettingChange && props.onViewSettingChange(_objectSpread$6(_objectSpread$6({}, viewSettings), formatAuxViewSettings(newAuxViewState)), {
        key: 'openedRails'
      });
      setAuxViewState(newAuxViewState);
    },
    useAuxView: function useAuxView(auxViewKey) {
      var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      // this function uses the prevState parameter to wait for useState to set the default auxViewState
      setAuxViewState(function (prevState) {
        var _newAuxViewState$auxV;

        var newAuxViewState = _objectSpread$6({}, prevState);

        newAuxViewState[auxViewKey].enabled = true;
        (_newAuxViewState$auxV = newAuxViewState[auxViewKey]).show || (_newAuxViewState$auxV.show = show); // only assign show if currently false

        return newAuxViewState;
      });
    },
    viewSettings: viewSettings
  }, layoutComponent)));
}

/**
 * Hook which triggers when a functional component has already been mounted (not triggered on first *unmounted) pass)
 * @param fn: function to trigger on component rerender
 * @param deps: dependency array
 * @hidden
 */

function useMountEffect(fn, deps) {
  var mounted = useRef(false);
  useEffect(function () {
    if (mounted.current) {
      fn();
    } else {
      mounted.current = true;
    }
  }, deps);
}

var _excluded$2 = ["initialFilters", "limit", "load", "page", "sort"],
    _excluded2$1 = ["total"],
    _excluded3 = ["sortDescriptor"];

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useInventory(options) {
  var initialFilters = options.initialFilters,
      limit = options.limit,
      load = options.load,
      initialPage = options.page,
      sort = options.sort,
      otherOpts = _objectWithoutProperties(options, _excluded$2);

  var _useState = useState(initialFilters || {}),
      _useState2 = _slicedToArray(_useState, 2),
      filters = _useState2[0],
      setFilters = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      total = _useState4[0],
      setTotal = _useState4[1];

  var _useState5 = useState(initialPage),
      _useState6 = _slicedToArray(_useState5, 2),
      page = _useState6[0],
      setPage = _useState6[1]; // custom load function to handle `total` value (for pagination)


  var pagedLoad = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(opts) {
      var _yield$load, total, data;

      return _regeneratorRuntime.wrap(function (_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return load(_objectSpread$5({
                filters: filters,
                limit: limit,
                page: page
              }, opts));

            case 2:
              _yield$load = _context.sent;
              total = _yield$load.total;
              data = _objectWithoutProperties(_yield$load, _excluded2$1);

              if (total != null) {
                setTotal(total);
              }

              if (page != null) {
                setPage(page + 1);
              }

              return _context.abrupt("return", _objectSpread$5({}, data));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function () {
      return _ref.apply(this, arguments);
    };
  }(), [filters, load]);
  var filtersSort = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(opts) {
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", sort(_objectSpread$5({
                filters: filters
              }, opts)));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function () {
      return _ref2.apply(this, arguments);
    };
  }(), [filters, sort]);

  var listOpts = _objectSpread$5(_objectSpread$5({}, otherOpts), {}, {
    load: pagedLoad
  }, sort && {
    sort: filtersSort
  });

  var list = useAsyncList(listOpts); // if filters are changed, reload the data (with filters as a parameter)
  // if sort is defined, do not trigger load if sortDescriptor changed

  var reloadDeps = sort ? [filters.collection, filters.filters, filters.folder, filters.query, filters.section, filters.pagination] : [filters];
  useMountEffect(function () {
    list.reload();
  }, reloadDeps); // split out sort descriptor as it is handled by the sort function (triggered by views) only if sort provided

  // TODO only return pagination if page is defined
  return _objectSpread$5(_objectSpread$5({}, list), {}, {
    pagination: (page != null || total != null) && {
      total: total,
      page: page,
      limit: limit
    },
    onLoadMore: list.loadMore,
    onFilterChange: function onFilterChange(newFilters) {
      var _filters$sortDescript, _filters$sortDescript2;

      var sortDescriptor = newFilters.sortDescriptor,
          otherFilters = _objectWithoutProperties(newFilters, _excluded3); // only call sort if sortDescriptor has changed


      if (sort && ((sortDescriptor === null || sortDescriptor === void 0 ? void 0 : sortDescriptor.column) !== ((_filters$sortDescript = filters.sortDescriptor) === null || _filters$sortDescript === void 0 ? void 0 : _filters$sortDescript.column) || (sortDescriptor === null || sortDescriptor === void 0 ? void 0 : sortDescriptor.direction) !== ((_filters$sortDescript2 = filters.sortDescriptor) === null || _filters$sortDescript2 === void 0 ? void 0 : _filters$sortDescript2.direction))) {
        list.sort(sortDescriptor);
      }

      setFilters(sort ? otherFilters : newFilters);
    },
    onSelectionChange: list.setSelectedKeys,
    defaultSelectedFilters: initialFilters
  });
}

var Breadcrumbs = function (props) {
  var path = props.path;

  var _useInventoryContext = useInventoryContext(),
      layout = _useInventoryContext.layout,
      onFilterChange = _useInventoryContext.onFilterChange,
      setPath = _useInventoryContext.setPath; // only clear filters if navigating breadcrumbs in rail


  // hoist path
  useEffect(function () {
    if (path) {
      setPath(path);
    }
  }, []);
  return /*#__PURE__*/React.createElement(Breadcrumbs$1, {
    path: path !== null && path !== void 0 ? path : [],
    onAction: function onAction(bc) {
      return onFilterChange('folder', bc, {
        isFolderNavigate: layout === 'rail'
      });
    }
  });
};

var messages$d = defineMessages({
  toggleColumns: {
    id: 'headers.toggleColumns',
    defaultMessage: 'Toggle columns'
  },
  customize: {
    id: 'headers.customize',
    defaultMessage: 'Customize'
  },
  apply: {
    id: 'dialog.apply',
    defaultMessage: 'Apply'
  },
  cancel: {
    id: 'dialog.cancel',
    defaultMessage: 'Cancel'
  },
  showColumns: {
    id: 'dialog.showColumns',
    defaultMessage: 'Select columns to show'
  }
}); // todo make this more generic? ViewSpecificButtonProps

/** @hidden */
function ColumnVisibilityDialog() {
  var _useInventoryContext = useInventoryContext(),
      onViewSettingChange = _useInventoryContext.onViewSettingChange,
      selectedViewLabel = _useInventoryContext.selectedViewLabel,
      tableColumns = _useInventoryContext.tableColumns,
      viewSettings = _useInventoryContext.viewSettings;

  var columnKeys = useMemo(function () {
    return (tableColumns || []).map(function (column) {
      return column.key;
    });
  }, []);

  var _useState = useState(viewSettings.hiddenColumns || []),
      _useState2 = _slicedToArray(_useState, 2),
      hiddenColumns = _useState2[0],
      setHiddenColumns = _useState2[1];

  var viewLabel = selectedViewLabel.size && Array.from(selectedViewLabel)[0];
  var dialog = useDialogContainer();

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var hasFixedColumns = tableColumns.filter(function (c) {
    return c.allowsToggle === false;
  }).length;
  var hasVisibleColumns = hiddenColumns.length < tableColumns.length - 1;
  return /*#__PURE__*/React.createElement(Dialog$2, {
    size: "S"
  }, /*#__PURE__*/React.createElement(Heading, null, formatMessage(messages$d.customize), " ", viewLabel), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(CheckboxGroup, {
    label: formatMessage(messages$d.showColumns),
    value: columnKeys.filter(function (key) {
      return !hiddenColumns.includes(key);
    }),
    onChange: function onColumnChange(selected) {
      var newHiddenColumns = columnKeys.filter(function (key) {
        return !selected.includes(key);
      });
      setHiddenColumns(newHiddenColumns);
    }
  }, tableColumns.map(function (column) {
    // if explicitly set to false, do not allow for toggling
    if (column.allowsToggle === false) {
      return null;
    }

    var isColumnVisible = !hiddenColumns.includes(column.key);
    return /*#__PURE__*/React.createElement(Checkbox, {
      key: column.key,
      value: column.key,
      isDisabled: !hasFixedColumns && !hasVisibleColumns && isColumnVisible
    }, column.label);
  }))), /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onPress: dialog.dismiss
  }, formatMessage(messages$d.cancel)), /*#__PURE__*/React.createElement(Button, {
    variant: "cta",
    onPress: function onConfirm() {
      onViewSettingChange('hiddenColumns', hiddenColumns);
      dialog.dismiss();
    }
  }, formatMessage(messages$d.apply))));
}

function ColumnToggle(props) {
  var _props$views = props.views,
      views = _props$views === void 0 ? [] : _props$views;

  var _useInventoryContext2 = useInventoryContext(),
      selectedViewLabel = _useInventoryContext2.selectedViewLabel;

  var _useIntl2 = useIntl(),
      formatMessage = _useIntl2.formatMessage;

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      open = _useState4[0],
      setOpen = _useState4[1];

  var viewLabel = selectedViewLabel.size && Array.from(selectedViewLabel)[0]; // hide if view not matching

  if (views.length && !views.includes(viewLabel)) {
    return null;
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TooltipTrigger, {
    delay: TOOLTIP_DELAY,
    placement: "top"
  }, /*#__PURE__*/React.createElement(ActionButton, {
    isQuiet: true,
    "aria-label": formatMessage(messages$d.toggleColumns),
    onPress: function onPress() {
      return setOpen(true);
    }
  }, /*#__PURE__*/React.createElement(ColumnSettings, null)), /*#__PURE__*/React.createElement(Tooltip, null, formatMessage(messages$d.customize), " ", viewLabel)), /*#__PURE__*/React.createElement(DialogContainer, {
    onDismiss: function onDismiss() {
      return setOpen(false);
    }
  }, open && /*#__PURE__*/React.createElement(ColumnVisibilityDialog, null)));
}

var messages$c = defineMessages({
  displayCount: {
    id: 'headers.displayCount',
    defaultMessage: '{displayCount} of {total}'
  },
  countMany: {
    id: 'headers.countMany',
    defaultMessage: '{displayCount} of many'
  }
});
function Counter(props) {
  var total = props.total;

  var _useInventoryContext = useInventoryContext(),
      items = _useInventoryContext.items,
      loadingState = _useInventoryContext.loadingState,
      pagination = _useInventoryContext.pagination;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var displayCount;

  if (items) {
    if (total == null) {
      // prioritize total prop
      total = pagination ? pagination.total : items.length;
    }

    if (pagination && pagination.page != null && total !== 'many') {
      var pageLimit = pagination.limit;
      var pageNumber = pagination.page;
      var denominator = pageLimit * pageNumber;

      if (denominator > total) {
        denominator = total;
      }

      displayCount = "".concat(pageLimit * (pageNumber - 1) + 1, "-").concat(denominator);
    } else {
      displayCount = items.length;
    }
  } // do not display if 0 total items or if loading


  if (!total || loadingState === 'loading') {
    return null;
  }

  var countStr = /*#__PURE__*/React.createElement("b", {
    key: "displayCount"
  }, displayCount);
  return /*#__PURE__*/React.createElement(View$1, null, total === 'many' ? formatMessage(messages$c.countMany, {
    displayCount: countStr
  }) : formatMessage(messages$c.displayCount, {
    displayCount: countStr,
    total: total
  }));
}

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function QuickFilter(props) {
  var _filterState$quickFil;

  var children = props.children,
      filterKey = props.filterKey,
      label = props.label;

  var _useInventoryContext = useInventoryContext(),
      filterState = _useInventoryContext.filterState,
      onFilterChange = _useInventoryContext.onFilterChange;

  return children({
    label: label,
    value: (_filterState$quickFil = filterState.quickFilters) === null || _filterState$quickFil === void 0 ? void 0 : _filterState$quickFil[filterKey],
    onFilterChange: function onCustomFilterChange(filterValue) {
      var newQuickFilterState = _objectSpread$4(_objectSpread$4({}, filterState.quickFilters), {}, _defineProperty({}, filterKey, filterValue));

      if (isNull(filterValue)) {
        delete newQuickFilterState[filterKey];
      }

      onFilterChange('quickFilters', newQuickFilterState);
    }
  });
}
function QuickFilterPicker(props) {
  var label = props.label,
      filterKey = props.filterKey,
      options = props.options,
      menuWidth = props.menuWidth;
  var allOption = options.find(function (option) {
    return option.isAllValue;
  });
  var allValue = allOption ? allOption.key : options[0].key; // default to [0] option being all value if none defined

  return /*#__PURE__*/React.createElement(QuickFilter, {
    filterKey: filterKey,
    label: label
  }, function (_ref) {
    var _ref2;

    var onFilterChange = _ref.onFilterChange,
        value = _ref.value;
    return /*#__PURE__*/React.createElement(Picker, {
      isQuiet: true,
      menuWidth: menuWidth,
      label: label,
      labelPosition: "side",
      items: options,
      selectedKey: (_ref2 = value) !== null && _ref2 !== void 0 ? _ref2 : allValue,
      onSelectionChange: function onSelectionChange(newValue) {
        return onFilterChange(newValue !== allValue ? newValue : null);
      }
    }, function (option) {
      return /*#__PURE__*/React.createElement(Item, {
        key: option.key
      }, option.label || option.key);
    });
  });
}
function QuickFilterActionGroup(props) {
  var label = props.label,
      filterKey = props.filterKey,
      options = props.options;
  var allOption = options.find(function (option) {
    return option.isAllValue;
  });
  var allValue = allOption ? allOption.key : options[0].key; // default to [0] option being all value if none defined

  return /*#__PURE__*/React.createElement(QuickFilter, {
    filterKey: filterKey,
    label: label
  }, function (_ref3) {
    var _ref4;

    var onFilterChange = _ref3.onFilterChange,
        value = _ref3.value;
    return /*#__PURE__*/React.createElement(ActionGroup, {
      isQuiet: true,
      "aria-label": label,
      items: options,
      selectionMode: "single",
      selectedKeys: [(_ref4 = value) !== null && _ref4 !== void 0 ? _ref4 : allValue],
      onAction: function onAction(newValue) {
        return onFilterChange(newValue !== allValue ? newValue : null);
      }
    }, function (option) {
      return /*#__PURE__*/React.createElement(Item, {
        key: option.key
      }, option.label || option.key);
    });
  });
}
function QuickFilterCheckbox(props) {
  var label = props.label,
      filterKey = props.filterKey;
  return /*#__PURE__*/React.createElement(QuickFilter, {
    filterKey: filterKey,
    label: label
  }, function (_ref5) {
    var _ref6;

    var onFilterChange = _ref5.onFilterChange,
        value = _ref5.value;
    return /*#__PURE__*/React.createElement(Checkbox, {
      isSelected: (_ref6 = value) !== null && _ref6 !== void 0 ? _ref6 : false,
      onChange: function onChange(newValue) {
        return onFilterChange(newValue);
      }
    }, label);
  });
}

var messages$b = defineMessages({
  sectionPicker: {
    id: 'headers.sectionPicker',
    defaultMessage: 'Section picker'
  }
});
function SectionPicker(props) {
  var sections = props.sections,
      disabledKeys = props.disabledKeys;

  var _useInventoryContext = useInventoryContext(),
      filterState = _useInventoryContext.filterState,
      onFilterChange = _useInventoryContext.onFilterChange;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/React.createElement(Picker, {
    "aria-label": formatMessage(messages$b.sectionPicker),
    width: "100%",
    disabledKeys: disabledKeys,
    defaultSelectedKey: filterState.section,
    onSelectionChange: function onChange(sectionKey) {
      return onFilterChange('section', sectionKey);
    }
  }, sections.map(function (section) {
    return /*#__PURE__*/React.createElement(Item, {
      key: section.key,
      textValue: section.key
    }, section.label || section.key);
  }));
}

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var messages$a = defineMessages({
  sortBy: {
    id: 'headers.sortBy',
    defaultMessage: 'Sort by'
  },
  sortDirection: {
    id: 'headers.sortDirection',
    defaultMessage: 'Sort direction'
  },
  chooseSortBy: {
    id: 'headers.chooseSortBy',
    defaultMessage: 'Choose sort by'
  }
}); // TODO: add select all checkbox

function ViewControl() {
  var _useInventoryContext = useInventoryContext(),
      onFilterChange = _useInventoryContext.onFilterChange,
      selectedSort = _useInventoryContext.selectedSort,
      setSelectedSort = _useInventoryContext.setSelectedSort,
      sortOptions = _useInventoryContext.sortOptions;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  if (!sortOptions || !sortOptions.length) {
    return null;
  } // Render the Sort Order Icon inside ActionButton


  var sortDirectionIcon = selectedSort.direction === 'descending' ? /*#__PURE__*/React.createElement(SortOrderDown, null) : /*#__PURE__*/React.createElement(SortOrderUp, null);

  var onSortChange = function (newSortDescriptor) {
    var sortDescriptor = {
      column: newSortDescriptor.column,
      direction: newSortDescriptor.direction
    };
    setSelectedSort(sortDescriptor);
    onFilterChange('sortDescriptor', sortDescriptor);
  };

  var onSortSelection = function (selected) {
    var selectedSortByObj = sortOptions.filter(function (option) {
      return option.column === selected;
    })[0];
    onSortChange(_objectSpread$3(_objectSpread$3({}, selectedSort), {}, {
      column: selectedSortByObj.column
    }));
  };

  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    margin: "size-100"
  }, /*#__PURE__*/React.createElement(Text, null, formatMessage(messages$a.sortBy)), /*#__PURE__*/React.createElement(View$1, {
    marginX: "size-100"
  }, /*#__PURE__*/React.createElement(ActionButton, {
    isQuiet: true,
    "aria-label": formatMessage(messages$a.sortDirection),
    onPress: function onSortDirectionPress() {
      var updatedSortDirection = selectedSort.direction === 'ascending' ? 'descending' : 'ascending';
      onSortChange(_objectSpread$3(_objectSpread$3({}, selectedSort), {}, {
        direction: updatedSortDirection
      }));
    }
  }, sortDirectionIcon)), /*#__PURE__*/React.createElement(Picker, {
    isQuiet: true,
    "aria-label": formatMessage(messages$a.chooseSortBy),
    items: sortOptions,
    defaultSelectedKey: selectedSort.column,
    onSelectionChange: function onSelectionChange(selected) {
      return onSortSelection(selected);
    }
  }, function (item) {
    return /*#__PURE__*/React.createElement(Item, {
      key: item.column
    }, item.label);
  }));
}

/** @hidden */

function TableView$1(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("title", null, "table"), /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: "36",
    height: "36",
    fill: "#ff13dc",
    fillOpacity: "0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ImportedIcons"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "20",
    width: "10",
    height: "6",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "12",
    width: "10",
    height: "6",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "20",
    width: "20",
    height: "6",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "14",
    y: "12",
    width: "20",
    height: "6",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,34H3a1,1,0,0,1-1-1V28H12Z",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,34H14V28H34v5A1,1,0,0,1,33,34Z",
    fill: "#6e6e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,2H3A1,1,0,0,0,2,3v7H34V3A1,1,0,0,0,33,2Z",
    fill: "#6e6e6e"
  }))));
}

var messages$9 = defineMessages({
  gridView: {
    id: 'views.gridView',
    defaultMessage: 'Grid view'
  },
  tableView: {
    id: 'views.tableView',
    defaultMessage: 'Table view'
  },
  listView: {
    id: 'views.listView',
    defaultMessage: 'List view'
  }
});
var viewMap = {
  table: {
    icon: /*#__PURE__*/React.createElement(TableView$1, null),
    labelKey: 'tableView'
  },
  grid: {
    icon: /*#__PURE__*/React.createElement(GridView, null),
    labelKey: 'gridView'
  },
  list: {
    icon: /*#__PURE__*/React.createElement(ViewList, null),
    labelKey: 'listView'
  }
};
function ViewToggle(props) {
  var children = props.children,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'group' : _props$variant;

  var _useInventoryContext = useInventoryContext(),
      onViewSelect = _useInventoryContext.onViewSelect,
      selectedViewLabel = _useInventoryContext.selectedViewLabel;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  if (variant === 'group') {
    return /*#__PURE__*/React.createElement(ActionGroup, {
      items: children,
      isQuiet: true,
      selectionMode: "single",
      disallowEmptySelection: true,
      selectedKeys: selectedViewLabel,
      onSelectionChange: function _onViewChange(selectedKeys) {
        if (_typeof(selectedKeys) === 'object' && selectedKeys.size === 1) {
          onViewSelect(Array.from(selectedKeys)[0]);
        }
      }
    }, function (item) {
      var _item$props = item.props,
          label = _item$props.label,
          value = _item$props.value,
          view = _item$props.view;
      var viewKey = value || view;
      return /*#__PURE__*/React.createElement(TooltipTrigger, {
        delay: TOOLTIP_DELAY,
        placement: "top",
        key: viewKey
      }, /*#__PURE__*/React.createElement(Item, {
        key: viewKey,
        textValue: value
      }, item), /*#__PURE__*/React.createElement(Tooltip, null, view ? formatMessage(messages$9[viewMap[view].labelKey]) : label));
    });
  } // button variant


  var selectedChild = React.Children.toArray(children).find(function (c) {
    return /*#__PURE__*/React.isValidElement(c) && c.props.key === selectedViewLabel[0];
  });

  if (!selectedChild || ! /*#__PURE__*/React.isValidElement(selectedChild)) {
    // TODO: might need better handler in case that selected view label isn't able to be found (would this happen?)
    return null;
  }

  var items = React.Children.map(children, function (child) {
    var _child$props = child.props,
        icon = _child$props.icon,
        label = _child$props.label,
        value = _child$props.value,
        view = _child$props.view;

    if (view) {
      return {
        key: value || view,
        icon: viewMap[view].icon,
        label: formatMessage(messages$9[viewMap[view].labelKey])
      };
    }

    return {
      key: value,
      icon: icon,
      label: label
    };
  });
  var _selectedChild$props = selectedChild.props,
      selectedIcon = _selectedChild$props.icon,
      selectedView = _selectedChild$props.view;
  return /*#__PURE__*/React.createElement(MenuTrigger, null, /*#__PURE__*/React.createElement(ActionButton, null, selectedView ? viewMap[selectedView].icon : selectedIcon), /*#__PURE__*/React.createElement(Menu, {
    selectionMode: "single",
    items: items,
    selectedKeys: selectedViewLabel,
    onAction: function onViewChange(selectedKeys) {
      if (selectedViewLabel !== selectedKeys[0]) {
        onViewSelect(selectedKeys);
      }
    }
  }, function (item) {
    return /*#__PURE__*/React.createElement(Item, {
      key: item.key,
      textValue: item.label
    }, /*#__PURE__*/React.cloneElement(item.icon, {
      size: 'S'
    }), /*#__PURE__*/React.createElement(Text, null, item.label));
  }));
}
var ViewButton = function (props) {
  var icon = props.icon,
      view = props.view;
  return view && viewMap[view] ? viewMap[view].icon : icon;
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var FilterGroup = function (_ref) {
  var title = _ref.title,
      children = _ref.children;

  var _useInventoryContext = useInventoryContext(),
      filterState = _useInventoryContext.filterState,
      onFilterChange = _useInventoryContext.onFilterChange;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View$1, null, /*#__PURE__*/React.createElement(Header, {
    marginBottom: "size-100"
  }, title), function (params) {
    if (typeof children === 'function') {
      return children(params);
    }

    return children;
  }({
    filterState: filterState.filters || {},
    onFilterChange: function onCustomFilterChange(key, value) {
      var newFilterState = _objectSpread$2(_objectSpread$2({}, filterState.filters || {}), {}, _defineProperty({}, key, value));

      onFilterChange('filters', newFilterState);
    },
    onSubmit: function onSubmit(state) {
      return onFilterChange('filters', state);
    }
  })), /*#__PURE__*/React.createElement(RailDivider, null));
};

var messages$8 = defineMessages({
  collections: {
    id: 'folderRail.collections',
    defaultMessage: 'Collections'
  }
});
function Collections(props) {
  var children = props.children;

  var _useInventoryContext = useInventoryContext(),
      onFilterChange = _useInventoryContext.onFilterChange;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/React.createElement(ListBox, {
    "aria-label": formatMessage(messages$8.collections),
    items: children,
    selectionMode: "single",
    selectedKeys: [],
    onSelectionChange: function onSelectionChange(selection) {
      return onFilterChange('collection', Array.from(selection)[0]);
    }
  }, function (item) {
    return /*#__PURE__*/React.createElement(Item, {
      key: item.props.value,
      textValue: item.props.children
    }, item);
  });
}
/** @hidden */

function Collection(props) {
  var children = props.children,
      icon = props.icon;
  return /*#__PURE__*/React.createElement(React.Fragment, null, icon && /*#__PURE__*/React.cloneElement(icon, {
    size: 'S'
  }), /*#__PURE__*/React.createElement(Text, null, children));
}

var css_248z = ".FolderTree-module_tree-view__2eBr6 {\n  height: 100%; }\n";
var styles = {"tree-view":"FolderTree-module_tree-view__2eBr6"};
styleInject(css_248z);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var messages$7 = defineMessages({
  loadingFolders: {
    id: 'folderPanel.loadingFolders',
    defaultMessage: 'Loading folders'
  }
});
// potential future API:
// - handle expandedKeys
// - custom rootFolder icon
// - custom sort
function FolderTree(props) {
  var folders = props.folders,
      isLoading = props.isLoading,
      onFolderExpand = props.onFolderExpand,
      path = props.path,
      rootFolder = props.rootFolder;

  var _useInventoryContext = useInventoryContext(),
      currentPath = _useInventoryContext.currentPath,
      onFilterChange = _useInventoryContext.onFilterChange;

  if (isLoading) {
    return /*#__PURE__*/React.createElement(Flex, {
      justifyContent: "center",
      alignItems: "center",
      height: "100%"
    }, /*#__PURE__*/React.createElement(ProgressCircle, {
      isIndeterminate: true,
      marginY: "16px"
    }));
  }

  return /*#__PURE__*/React.createElement(FolderPanel, {
    root: rootFolder,
    folders: folders,
    selectedPath: currentPath || path,
    onSelect: function onFolderSelect(folder) {
      return onFilterChange('folder', folder);
    },
    onExpand: onFolderExpand
  });
}
/** @hidden */

function FolderPanelItem(props) {
  // TODO: handle thumbnail?
  var folder = props.folder,
      item = props.item;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var icon = item.isExpanded && item.hasChildren && !item.isLoading ? /*#__PURE__*/React.createElement(FolderOpen, {
    size: "S"
  }) : /*#__PURE__*/React.createElement(Folder, {
    size: "S"
  });
  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    gap: "size-100"
  }, icon, /*#__PURE__*/React.createElement(Text, null, folder.label), item.isLoading && /*#__PURE__*/React.createElement(ProgressCircle, {
    "aria-label": formatMessage(messages$7.loadingFolders),
    isIndeterminate: true,
    size: "S"
  }));
}

var FolderPanelDataSource = /*#__PURE__*/function (_TreeViewDataSource) {
  _inherits(FolderPanelDataSource, _TreeViewDataSource);

  var _super = _createSuper(FolderPanelDataSource);

  function FolderPanelDataSource(folders, opts) {
    var _this;

    _classCallCheck(this, FolderPanelDataSource);

    _this = _super.call(this, {
      isItemEqual: function isItemEqual(a, b) {
        return a.key === b.key;
      }
    });
    _this.loaded = void 0;
    _this.rootFolder = void 0;
    _this.folderItemMap = void 0;
    _this.childrenMap = void 0;
    _this.onFolderSelect = void 0;
    _this.expandedKeys = void 0;
    _this.loaded = false;
    _this.folderItemMap = {};
    _this.childrenMap = {};
    _this.expandedKeys = new Set();
    _this.rootFolder = !opts.root ? null : {
      label: opts.root,
      isRootFolder: true
    };
    _this.onExpand = opts.onExpand;
    _this.onFolderSelect = opts.onFolderSelect;

    _this.on('load', function () {
      _this.loaded = true;

      if (opts.selectedPath) {
        _this.selectNestedFolder(opts.selectedPath);
      }
    });

    return _this;
  }

  _createClass(FolderPanelDataSource, [{
    key: "setExpanded",
    value: function setExpanded(key, expanded) {
      if (!key) {
        key = 'ROOT_ITEM';
      }

      if (expanded) {
        this.expandedKeys.add(key);
      } else {
        this.expandedKeys["delete"](key);
      }
    }
  }, {
    key: "collapseItem",
    value: function collapseItem(item) {
      _get(_getPrototypeOf(FolderPanelDataSource.prototype), "collapseItem", this).call(this, item);

      this.setExpanded(item.key || null, false);
    }
  }, {
    key: "expandItem",
    value: function () {
      var _expandItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item) {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setExpanded(item.key || null, true);

                _get(_getPrototypeOf(FolderPanelDataSource.prototype), "expandItem", this).call(this, item);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function expandItem() {
        return _expandItem.apply(this, arguments);
      };
    }()
  }, {
    key: "populateLookup",
    value: function populateLookup(folders) {
      var itemMap = {};
      var childrenMap = {};
      folders.forEach(function (f) {
        var parent = f.parentKey || '';
        itemMap[f.key] = {
          key: f.key,
          label: f.label,
          parentKey: parent,
          folder: f
        };

        if (!childrenMap[parent]) {
          childrenMap[parent] = [f.key];
        } else {
          childrenMap[parent].push(f.key);
        }
      });
      return [itemMap, childrenMap];
    }
  }, {
    key: "selectNestedFolder",
    value: function () {
      var _selectNestedFolder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path) {
        var _this2 = this;

        var newPath, selected, _iterator, _step, _folder, item;

        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                newPath = _toConsumableArray(path);

                if (!this.rootFolder) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.expandItem(this.rootFolder);

              case 4:
                selected = newPath.pop();
                _iterator = _createForOfIteratorHelper(newPath);
                _context2.prev = 6;

                _iterator.s();

              case 8:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 16;
                  break;
                }

                _folder = _step.value;
                item = this.folderItemMap[_folder.key];

                if (!item) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 14;
                return this.expandItem(item);

              case 14:
                _context2.next = 8;
                break;

              case 16:
                _context2.next = 21;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](6);

                _iterator.e(_context2.t0);

              case 21:
                _context2.prev = 21;

                _iterator.f();

                return _context2.finish(21);

              case 24:
                // hack to get the folder to select (needs to be in new thread and/or a fraction later
                setTimeout(function () {
                  var item = _this2.folderItemMap[selected.key];

                  if (item) {
                    _this2.onFolderSelect(item);
                  }
                }, 300);

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 18, 21, 24]]);
      }));

      return function selectNestedFolder() {
        return _selectNestedFolder.apply(this, arguments);
      };
    }()
  }, {
    key: "getChildren",
    value: function () {
      var _getChildren = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(item) {
        var _this3 = this;

        var parentKey, result, folders;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!item && this.rootFolder)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", [this.rootFolder]);

              case 2:
                parentKey = (item === null || item === void 0 ? void 0 : item.key) || ''; // return cached results

                if (!this.childrenMap[parentKey]) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return", this.childrenMap[parentKey].map(function (folderKey) {
                  return _this3.folderItemMap[folderKey];
                }));

              case 5:
                result = [];
                folders = [];

                if (!this.onExpand) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 10;
                return this.onExpand(item);

              case 10:
                result = _context3.sent;
                result.forEach(function (folder) {
                  var item = {
                    key: folder.key,
                    label: folder.label,
                    parentKey: folder.parentKey,
                    folder: folder
                  };
                  folders.push(item);
                  _this3.folderItemMap[folder.key] = item;
                });

              case 12:
                this.childrenMap[parentKey] = folders;
                return _context3.abrupt("return", folders);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      return function getChildren() {
        return _getChildren.apply(this, arguments);
      };
    }()
  }, {
    key: "hasChildren",
    value: function hasChildren(parent) {
      // default show expand caret if onExpand is defined or parent has children as dictated by folderItemMap
      return this.onExpand || parent.isRootFolder || this.childrenMap[parent.key] && this.childrenMap[parent.key].length;
    }
  }, {
    key: "updateFolders",
    value: function () {
      var _updateFolders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(newFolders) {
        var _this4 = this;

        var _this$populateLookup, _this$populateLookup2, _newItemMap, _newChildrenMap, _this$populateLookup3, _this$populateLookup4, newItemMap, newChildrenMap, _i, _Array$from, key, item;

        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (this.loaded) {
                  _context4.next = 5;
                  break;
                }

                _this$populateLookup = this.populateLookup(newFolders), _this$populateLookup2 = _slicedToArray(_this$populateLookup, 2), _newItemMap = _this$populateLookup2[0], _newChildrenMap = _this$populateLookup2[1];
                this.folderItemMap = _newItemMap;
                this.childrenMap = _newChildrenMap;
                return _context4.abrupt("return");

              case 5:
                this.startTransaction();
                Object.values(this.folderItemMap).forEach(function (f) {
                  _this4.removeItem(f); // TODO use removeChild???

                });
                _this$populateLookup3 = this.populateLookup(newFolders), _this$populateLookup4 = _slicedToArray(_this$populateLookup3, 2), newItemMap = _this$populateLookup4[0], newChildrenMap = _this$populateLookup4[1];
                Object.keys(newChildrenMap).forEach(function (key) {
                  var parent;

                  if (key !== '') {
                    parent = newItemMap[key];
                  } else if (_this4.rootFolder) {
                    parent = _this4.rootFolder;
                  }

                  newChildrenMap[key].forEach(function (childKey, i) {
                    var item = newItemMap[childKey];

                    _this4.insertChild(parent, i, item);
                  });
                });
                _i = 0, _Array$from = Array.from(this.expandedKeys);

              case 10:
                if (!(_i < _Array$from.length)) {
                  _context4.next = 22;
                  break;
                }

                key = _Array$from[_i];
                item = newItemMap[key];

                if (item) {
                  _context4.next = 17;
                  break;
                }

                this.expandedKeys["delete"](key);
                _context4.next = 19;
                break;

              case 17:
                _context4.next = 19;
                return this.expandItem(item);

              case 19:
                _i++;
                _context4.next = 10;
                break;

              case 22:
                this.endTransaction(); // set maps

                this.folderItemMap = newItemMap;
                this.childrenMap = newChildrenMap;

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      return function updateFolders() {
        return _updateFolders.apply(this, arguments);
      };
    }()
  }]);

  return FolderPanelDataSource;
}(TreeViewDataSource);
/** @hidden */


function FolderPanel(props) {
  var folders = props.folders,
      onExpand = props.onExpand,
      onSelect = props.onSelect,
      root = props.root,
      selectedPath = props.selectedPath;

  var _useState = useState({
    key: root
  }),
      _useState2 = _slicedToArray(_useState, 2),
      selectedFolder = _useState2[0],
      setSelectedFolder = _useState2[1];

  var onFolderSelect = function (folder) {
    setSelectedFolder(folder);
  };

  var dataSource = useMemo(function () {
    return new FolderPanelDataSource(folders, {
      root: root,
      onExpand: onExpand,
      selectedPath: selectedPath,
      onFolderSelect: onFolderSelect
    });
  }, []);
  useEffect(function () {
    if (!folders) {
      return;
    }

    dataSource.updateFolders(folders);
  }, [folders]); // todo handle selected path change and folder change

  return /*#__PURE__*/React.createElement(TreeView, {
    className: styles['tree-view'],
    allowsSelection: true,
    dataSource: dataSource,
    onSelectionChange: function onSelectionChange(selected) {
      if (!selected || selected.length === 0) {
        return;
      }

      if (selected[0].key !== selectedFolder.key) {
        setSelectedFolder(selected[0]);
      }

      onSelect && onSelect(selected[0].key);
    },
    renderItem: function renderItem(folder, item) {
      return /*#__PURE__*/React.createElement(FolderPanelItem, {
        folder: folder,
        item: item
      });
    },
    selectedItems: selectedFolder ? [selectedFolder] : []
  });
}

var messages$6 = defineMessages({
  remove: {
    id: 'selectedItem.remove',
    defaultMessage: 'Remove'
  }
});
function SelectedItem(props) {
  var children = props.children,
      value = props.value;

  var _useInventoryContext = useInventoryContext(),
      onSelectionChange = _useInventoryContext.onSelectionChange,
      selection = _useInventoryContext.selection;

  var _useContext = useContext(SelectionRailContext),
      getKey = _useContext.getKey;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(View$1, {
    flexGrow: 1,
    marginStart: "10px",
    marginTop: "5px"
  }, children), /*#__PURE__*/React.createElement(ActionButton, {
    "aria-label": formatMessage(messages$6.remove),
    flexGrow: 0,
    flexShrink: 0,
    isQuiet: true,
    onPress: function handleClick() {
      var newSelections = new Set(selection);
      newSelections["delete"](getKey(value)); // handle everything in onSelectionChange

      onSelectionChange(newSelections);
    }
  }, /*#__PURE__*/React.createElement(Close, null)));
}

function BulkActionBar(props) {
  var _useComponentContext = useComponentContext(),
      setComponent = _useComponentContext.setComponent;

  var _useInventoryContext = useInventoryContext(),
      selection = _useInventoryContext.selection,
      onSelectionChange = _useInventoryContext.onSelectionChange;

  var actions = typeof props.actions === 'function' ? props.actions(selection) : props.actions;

  var onClearSelection = function () {
    return onSelectionChange(new Set([]));
  };

  var onAction = function (actionKey) {
    var action = actions.find(function (action) {
      return action.key === actionKey;
    });
    action && action.onPress && action.onPress(selection);
  };

  useEffect(function () {
    var selectedCount = selection === 'all' ? 'all' : selection.size; // only show bulk action bar if more than 1 item is selected

    setComponent(ComponentType.BULK_ACTION_BAR, selectedCount < 2 ? null : /*#__PURE__*/React.createElement(ActionBar, {
      isEmphasized: true,
      onAction: onAction,
      selectedItemCount: selectedCount,
      onClearSelection: onClearSelection
    }, actions.map(function (action) {
      var item = /*#__PURE__*/React.createElement(Item, {
        key: action.key
      }, action.icon, /*#__PURE__*/React.createElement(Text, null, action.label));
      return action.dialog ? /*#__PURE__*/React.createElement(DialogTrigger, null, item, function (close) {
        return action.dialog(selection, close);
      }) : item;
    })));
  }, [selection]);
  return null;
}

var messages$5 = defineMessages({
  favorite: {
    id: 'headers.favorite',
    defaultMessage: 'Favorite'
  }
});
function Favorite(props) {
  var _props$icon;

  var isSelected = props.isSelected,
      _onPress = props.onPress,
      value = props.value;
  var starIcon = isSelected ? /*#__PURE__*/React.createElement(Star, null) : /*#__PURE__*/React.createElement(StarOutline, null);
  var icon = (_props$icon = props.icon) !== null && _props$icon !== void 0 ? _props$icon : starIcon;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/React.createElement(ActionButton, {
    isQuiet: true,
    "aria-label": formatMessage(messages$5.favorite),
    "aria-pressed": isSelected,
    onPress: function onPress() {
      return _onPress && _onPress(!isSelected, value);
    }
  }, isSelected ? /*#__PURE__*/React.cloneElement(icon, {
    UNSAFE_style: {
      fill: 'rgb(52, 116, 222)'
    }
  }) : icon);
}

var messages$4 = defineMessages({
  moreActions: {
    id: 'views.moreActions',
    defaultMessage: 'More actions'
  }
});
function ItemActionButton(props) {
  var actions = props.actions,
      value = props.value;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      dialog = _useState2[0],
      setDialog = _useState2[1];

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  if (!actions.length) {
    return null;
  }

  var action = actions[0];
  var button = /*#__PURE__*/React.createElement(ActionButton, {
    "aria-label": actions.length > 1 ? formatMessage(messages$4.moreActions) : action.label || action.key,
    isQuiet: true,
    isDisabled: actions.length === 1 && action.isDisabled && action.isDisabled(value),
    onPress: function onPress() {
      var _action$onPress;

      return actions.length === 1 && (action === null || action === void 0 ? void 0 : (_action$onPress = action.onPress) === null || _action$onPress === void 0 ? void 0 : _action$onPress.call(action, value));
    }
  }, actions.length > 1 ? /*#__PURE__*/React.createElement(MoreSmall, null) : action.icon);

  if (actions.length > 1) {
    var disabledKeys = actions.filter(function (a) {
      return a.isDisabled && a.isDisabled(value);
    }).map(function (a) {
      return a.key;
    });
    button = /*#__PURE__*/React.createElement(TooltipTrigger, {
      delay: TOOLTIP_DELAY
    }, /*#__PURE__*/React.createElement(MenuTrigger, null, button, /*#__PURE__*/React.createElement(Menu, {
      items: actions,
      onAction: function onAction(key) {
        var pressedAction = actions.find(function (action) {
          return action.key === key;
        });
        pressedAction.dialog ? setDialog(pressedAction.dialog(value)) : pressedAction.onPress(value);
      },
      disabledKeys: disabledKeys
    }, function (action) {
      return /*#__PURE__*/React.createElement(Item, {
        textValue: action.label || action.key
      }, /*#__PURE__*/React.cloneElement(action.icon, {
        size: 'S'
      }), action.label && /*#__PURE__*/React.createElement(Text, null, action.label));
    })), /*#__PURE__*/React.createElement(Tooltip, null, formatMessage(messages$4.moreActions)));
  } else if (actions.length === 1) {
    // only add dialog trigger if single action button
    if (action.dialog) {
      var _action$hideArrow;

      button = /*#__PURE__*/React.createElement(DialogTrigger, {
        hideArrow: (_action$hideArrow = action.hideArrow) !== null && _action$hideArrow !== void 0 ? _action$hideArrow : true,
        type: action.dialogType || 'modal',
        placement: action.dialogPlacement || "bottom left"
      }, button, function (close) {
        return action.dialog(value, close);
      });
    } // add tooltip if label present


    if (action.label) {
      button = /*#__PURE__*/React.createElement(TooltipTrigger, {
        delay: TOOLTIP_DELAY
      }, button, /*#__PURE__*/React.createElement(Tooltip, null, action.label));
    }
  } // if any action has a dialog, place a container


  if (action && action.dialog || actions && actions.some(function (a) {
    return !!a.dialog;
  })) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, button, /*#__PURE__*/React.createElement(DialogContainer, {
      onDismiss: function onDismiss() {
        return setDialog(null);
      }
    }, dialog));
  }

  return button;
}

var viewCount = {};
var viewTypeMap = {};
function useViewSetup(label, type) {
  var _useInventoryContext = useInventoryContext(),
      id = _useInventoryContext.id,
      onViewSelect = _useInventoryContext.onViewSelect,
      selectedViewLabel = _useInventoryContext.selectedViewLabel;

  useEffect(function () {
    if (!viewCount[id]) {
      viewCount[id] = 0;
      viewTypeMap[id] = {};
    } // set the selected view to the first one being registered


    if (viewCount[id]++ === 0 && !selectedViewLabel.size) {
      onViewSelect(label);
    }

    viewTypeMap[id][label] = type;
    return function () {
      // if view count for id key goes to 0, remove key to prevent counter object from growing too large
      if (--viewCount[id] === 0) {
        delete viewCount[id];
        delete viewTypeMap[id];
      }
    };
  }, []);
  return selectedViewLabel.has(label);
}

var messages$3 = defineMessages({
  list: {
    id: 'views.list',
    defaultMessage: 'list'
  },
  listView: {
    id: 'views.listView',
    defaultMessage: 'List view'
  }
});
var ListContext = /*#__PURE__*/React.createContext(null);
/** @hidden */

function ListContextProvider(props) {
  var actions = props.actions,
      children = props.children,
      draggable = props.draggable,
      getDragItems = props.getDragItems,
      onSelect = props.onSelect,
      renderDragPreview = props.renderDragPreview;
  return /*#__PURE__*/React.createElement(ListContext.Provider, {
    value: {
      actions: actions,
      draggable: draggable,
      getDragItems: getDragItems,
      onSelect: onSelect,
      renderDragPreview: renderDragPreview
    }
  }, children);
}
function ListView(props) {
  var _props$actions = props.actions,
      actions = _props$actions === void 0 ? [] : _props$actions,
      children = props.children,
      _props$draggable = props.draggable,
      draggable = _props$draggable === void 0 ? false : _props$draggable,
      getDragItems = props.getDragItems,
      _props$label = props.label,
      label = _props$label === void 0 ? 'list' : _props$label,
      renderDragPreview = props.renderDragPreview;

  var _useInventoryContext = useInventoryContext(),
      items = _useInventoryContext.items,
      loadingState = _useInventoryContext.loadingState,
      onSelectionChange = _useInventoryContext.onSelectionChange,
      renderEmptyState = _useInventoryContext.renderEmptyState;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage; // only show view if selected


  if (!useViewSetup(label, formatMessage(messages$3.list))) {
    return null;
  }

  /*
    TODO: with next alpha of listview
    - remove className
    - convert isLoading to loadingState on next alpha of listview
    - add selection/selectionMode
    - disabledKeys
   */
  return /*#__PURE__*/React.createElement(ListContextProvider, {
    actions: actions,
    onSelect: function onSelect(item) {
      var selected = new Set([_typeof(item) === 'object' ? item.key : item]);
      onSelectionChange(selected);
    },
    draggable: draggable,
    getDragItems: getDragItems,
    renderDragPreview: renderDragPreview
  }, /*#__PURE__*/React.createElement(ListView$1, {
    "aria-label": formatMessage(messages$3.listView),
    UNSAFE_className: styles$1['inventory-listview'],
    items: items,
    isLoading: loadingState === 'loading',
    renderEmptyState: renderEmptyState
  }, typeof children !== 'function' ? children : function (item) {
    return children(item);
  }));
}

var messages$2 = defineMessages({
  dragHandle: {
    id: 'list.dragHandle',
    defaultMessage: 'Drag handle'
  }
});
function ListItem(props) {
  var itemActions = props.actions,
      children = props.children,
      icon = props.icon,
      isFolder = props.isFolder,
      title = props.title,
      subtitle = props.subtitle,
      value = props.value;

  var _useContext = useContext(ListContext),
      listActions = _useContext.actions,
      draggable = _useContext.draggable,
      getDragItems = _useContext.getDragItems,
      onSelect = _useContext.onSelect,
      renderDragPreview = _useContext.renderDragPreview;

  var _useInventoryContext = useInventoryContext(),
      onFilterChange = _useInventoryContext.onFilterChange;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var item = value || typeof children === 'string' && children || title; // use value prop, string child, or title

  var visual = icon;

  if (isFolder && !icon) {
    visual = /*#__PURE__*/React.createElement(Folder, {
      flexShrink: 0,
      marginX: "10px"
    });
  }

  var center; // TODO utilize listview item slots so we don't need custom css

  var centerStyleProps = visual ? {
    padding: '0 8px'
  } : {};

  if (title) {
    center = /*#__PURE__*/React.createElement(Flex, {
      direction: "column",
      flexGrow: 1,
      minWidth: 0,
      UNSAFE_style: centerStyleProps
    }, /*#__PURE__*/React.createElement(View$1, null, title), subtitle && /*#__PURE__*/React.createElement(View$1, null, subtitle));
  } else {
    center = /*#__PURE__*/React.createElement(View$1, {
      flexGrow: 1,
      minWidth: 0,
      UNSAFE_style: centerStyleProps
    }, children);
  } // right area


  var right;
  var actions = itemActions || listActions;

  if (isFolder) {
    // folders do not use list actions, use only actions placed directly on list item
    right = /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center"
    }, itemActions && itemActions.length > 0 && /*#__PURE__*/React.createElement(ItemActionButton, {
      actions: itemActions,
      value: item
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        width: '34px',
        display: 'flex',
        justifyContent: 'center'
      }
    }, /*#__PURE__*/React.createElement(ChevronRight, {
      flexShrink: 0
    })));
  } else if (actions && actions.length) {
    right = /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(ItemActionButton, {
      actions: [actions[0]],
      value: item
    }), actions.length > 1 && /*#__PURE__*/React.createElement(ItemActionButton, {
      actions: actions.slice(1),
      value: item
    }));
  }

  var provider = useProvider();

  var _renderPreview = renderDragPreview !== null && renderDragPreview !== void 0 ? renderDragPreview : function () {
    return /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center",
      width: "250px"
    }, visual, center);
  };

  var _useDrag = useDrag({
    getItems: function getItems() {
      return getDragItems ? getDragItems([item]) : [{
        item: JSON.stringify(item)
      }];
    },
    getAllowedDropOperations: function getAllowedDropOperations() {
      return ['copy'];
    },
    renderPreview: function renderPreview() {
      return /*#__PURE__*/React.createElement(Provider$1, provider, _renderPreview(item));
    }
  }),
      dragProps = _useDrag.dragProps;

  return /*#__PURE__*/React.createElement("div", _extends({
    onClick: function onPress(item) {
      if (isFolder) {
        onFilterChange('folder', item, {
          isFolderNavigate: true
        });
      } else {
        onSelect(item);
      }
    }.bind(null, item)
  }, draggable && dragProps), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center"
  }, draggable && /*#__PURE__*/React.createElement(View$1, {
    marginEnd: "10px"
  }, /*#__PURE__*/React.createElement(DragHandle, {
    size: "XS",
    "aria-label": formatMessage(messages$2.dragHandle)
  })), visual, center, right));
}

var messages$1 = defineMessages({
  list: {
    id: 'views.list',
    defaultMessage: 'list'
  },
  table: {
    id: 'views.table',
    defaultMessage: 'table'
  },
  grid: {
    id: 'views.grid',
    defaultMessage: 'grid'
  },
  view: {
    id: 'views.view',
    defaultMessage: 'view'
  }
});
function View(props) {
  var children = props.children,
      label = props.label,
      type = props.type;

  var _useInventoryContext = useInventoryContext(),
      disabledKeys = _useInventoryContext.disabledKeys,
      loadingState = _useInventoryContext.loadingState,
      items = _useInventoryContext.items,
      onLoadMore = _useInventoryContext.onLoadMore,
      onSelectionChange = _useInventoryContext.onSelectionChange,
      renderEmptyState = _useInventoryContext.renderEmptyState,
      selectedKeys = _useInventoryContext.selectedKeys,
      selectedSort = _useInventoryContext.selectedSort,
      selection = _useInventoryContext.selection,
      selectionMode = _useInventoryContext.selectionMode,
      viewSettings = _useInventoryContext.viewSettings;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var show = useViewSetup(label, formatMessage(type ? messages$1[type] : messages$1.view)); // if no label is provided, assume single View component and show

  if (label && !show) {
    return null;
  }

  return typeof children !== 'function' ? children : children({
    disabledKeys: disabledKeys,
    items: items,
    loadingState: loadingState,
    onLoadMore: onLoadMore,
    onSelectionChange: onSelectionChange,
    renderEmptyState: renderEmptyState,
    selectedKeys: selectedKeys,
    selectedSort: selectedSort,
    selection: selection,
    selectionMode: selectionMode,
    viewSettings: viewSettings
  });
}

var _excluded$1 = ["children", "icon", "isFolder", "onPress", "value"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
// - video thumbnail (icon over preview)

/** @hidden */
function CellBase(props) {
  var children = props.children,
      icon = props.icon,
      thumbnail = props.thumbnail,
      thumbnailAlt = props.thumbnailAlt;
  var visual = null;

  if (thumbnail) {
    visual = /*#__PURE__*/React.createElement(Image, {
      src: thumbnail,
      alt: thumbnailAlt,
      objectFit: "contain",
      height: "30px",
      width: "30px",
      flexShrink: 0
    });
  } else if (icon) {
    visual = /*#__PURE__*/React.cloneElement(icon, _objectSpread$1({
      flexShrink: 0
    }, icon.props));
  }

  if (!thumbnail && !icon) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    gap: "size-100"
  }, visual, children);
}
function NameCell(props) {
  var children = props.children,
      icon = props.icon,
      _props$isFolder = props.isFolder,
      isFolder = _props$isFolder === void 0 ? false : _props$isFolder,
      onPress = props.onPress,
      value = props.value,
      cellProps = _objectWithoutProperties(props, _excluded$1);

  // use value prop or string child
  var _useInventoryContext = useInventoryContext(),
      onFilterChange = _useInventoryContext.onFilterChange;

  return /*#__PURE__*/React.createElement(CellBase, _extends({
    icon: icon !== undefined ? icon : isFolder && /*#__PURE__*/React.createElement(Folder, null)
  }, cellProps), /*#__PURE__*/React.createElement(Link, {
    isQuiet: true,
    onPress: function onLinkPress(item) {
      isFolder && onFilterChange('folder', item, {
        isFolderNavigate: true
      });
      onPress && onPress(item);
    }.bind(null, value || typeof children === 'string' && children)
  }, children));
}

var _excluded = ["children", "columns", "label"],
    _excluded2 = ["key", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var messages = defineMessages({
  table: {
    id: 'views.table',
    defaultMessage: 'table'
  },
  tableView: {
    id: 'views.tableView',
    defaultMessage: 'Table view'
  }
});
function TableView(props) {
  var children = props.children,
      _props$columns = props.columns,
      columns = _props$columns === void 0 ? [] : _props$columns,
      _props$label = props.label,
      label = _props$label === void 0 ? 'table' : _props$label,
      otherProps = _objectWithoutProperties(props, _excluded);

  var _useInventoryContext = useInventoryContext(),
      disabledKeys = _useInventoryContext.disabledKeys,
      loadingState = _useInventoryContext.loadingState,
      items = _useInventoryContext.items,
      onFilterChange = _useInventoryContext.onFilterChange,
      onLoadMore = _useInventoryContext.onLoadMore,
      onSelectionChange = _useInventoryContext.onSelectionChange,
      renderEmptyState = _useInventoryContext.renderEmptyState,
      selectedSort = _useInventoryContext.selectedSort,
      selection = _useInventoryContext.selection,
      selectionMode = _useInventoryContext.selectionMode,
      setSelectedSort = _useInventoryContext.setSelectedSort,
      setTableColumns = _useInventoryContext.setTableColumns,
      tableColumns = _useInventoryContext.tableColumns,
      sortOptions = _useInventoryContext.sortOptions,
      viewSettings = _useInventoryContext.viewSettings;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  useEffect(function () {
    setTableColumns(columns);
  }, [columns]);
  useEffect(function () {
    // dispatch resize event for issue where header cells become misaligned with columns (header width's don't resize)
    window.dispatchEvent(new Event('resize'));
  }, [items]); // only show view if selected

  if (!useViewSetup(label, formatMessage(messages.table))) {
    return null;
  }

  var sortDescriptor = !selectedSort ? null : _objectSpread({}, selectedSort);
  var visibleColumns = [];
  var hiddenColumns = viewSettings.hiddenColumns || [];
  tableColumns.forEach(function (c) {
    if (!hiddenColumns.includes(c.key)) {
      visibleColumns.push(c);
    }
  }); // other props spread to enable data-* props

  return /*#__PURE__*/React.createElement(TableView$2, _extends({}, otherProps, {
    "aria-label": formatMessage(messages.tableView),
    flexGrow: 1,
    selectionMode: selectionMode,
    selectedKeys: selection,
    disabledKeys: disabledKeys,
    sortDescriptor: sortDescriptor,
    onSortChange: function onSortChange(newSortDescriptor) {
      setSelectedSort(newSortDescriptor);
      onFilterChange('sortDescriptor', newSortDescriptor);
    },
    density: viewSettings.density,
    onSelectionChange: function handleOnSelectionChange(selectedKeys) {
      return onSelectionChange(selectedKeys);
    },
    renderEmptyState: renderEmptyState
  }), /*#__PURE__*/React.createElement(TableHeader, {
    columns: visibleColumns
  }, function (_ref) {
    var key = _ref.key,
        label = _ref.label,
        columnProps = _objectWithoutProperties(_ref, _excluded2);

    return /*#__PURE__*/React.createElement(Column, _extends({
      key: key
    }, columnProps, {
      allowsSorting: sortOptions.findIndex(function (option) {
        return option.column === key;
      }) > -1
    }), label);
  }), /*#__PURE__*/React.createElement(TableBody, {
    items: items || [],
    loadingState: loadingState,
    onLoadMore: onLoadMore
  }, children));
}

export { Breadcrumbs, BulkActionBar, Collection, Collections, ColumnToggle, Counter, Dialog$1 as Dialog, Favorite, FilterDialog, FilterDialogContext, FilterGroup, FilterList, FilterRail, FilterTag, FilterValue, FolderPanel, FolderRail, FolderTree, Inventory, ItemActionButton, ListItem, ListView, NameCell, PageHeader, Pagination, QuickFilter, QuickFilterActionGroup, QuickFilterCheckbox, QuickFilterPicker, RailDivider, RailHeader, Search, SectionPicker, SelectedItem, SelectionCount, SelectionRail, SelectionRailContext, SelectionRailContextProvider, TableView, View, ViewButton, ViewControl, ViewHeader, ViewToggle, getSelectionCountString, getSelectionString, renderEmptyState, useInventory };
